import SC from './style';

interface SvgProps {
  width?: string;
  hasHover?: boolean;
  color?: string;
  selected?: boolean;
  hasTransition?: boolean;
  hovered?: any;
}

export const SvgAllProgram = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 34.107 34.107">
    <defs>
      <linearGradient id="linear-gradient" x1="-0.091" y1="0.188" x2="0.931" y2="0.824" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#5833ff" />
        <stop offset="0.423" stopColor="#175df9" />
        <stop offset="1" stopColor="#21ffcf" />
      </linearGradient>
    </defs>
    <g id="Groupe_9282" data-name="Groupe 9282" transform="translate(-1748.821 -97.696)">
      <g id="Groupe_9278" data-name="Groupe 9278" transform="translate(1748.821 97.696)">
        <rect
          id="Rectangle_10562"
          data-name="Rectangle 10562"
          width="100%"
          height="100%"
          rx="17.054"
          transform="translate(0 0)"
          fill="url(#linear-gradient)"
        />
      </g>
      <path
        id="Tracé_10705"
        data-name="Tracé 10705"
        d="M1759.851,109.827l6.079,6.079-6.079,6.079"
        transform="translate(2.984 -1.199)"
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </g>
  </svg>
);

export const SvgCadenasClose = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 11.57 13.223">
    <path
      id="Icon_awesome-lock"
      data-name="Icon awesome-lock"
      d="M10.33,5.785H9.71V3.925a3.925,3.925,0,0,0-7.851,0V5.785H1.24A1.24,1.24,0,0,0,0,7.025v4.958a1.24,1.24,0,0,0,1.24,1.24H10.33a1.24,1.24,0,0,0,1.24-1.24V7.025A1.24,1.24,0,0,0,10.33,5.785Zm-2.686,0H3.925V3.925a1.859,1.859,0,0,1,3.719,0Z"
      style={{ fill: '#000' }}
    />
  </svg>
);

export const SvgCadenas = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 14.876 13.223">
    <path
      data-name="Icon awesome-lock-open"
      d="M10.938 0a3.951 3.951 0 0 0-3.913 3.964v1.821H1.24A1.24 1.24 0 0 0 0 7.025v4.959a1.24 1.24 0 0 0 1.24 1.24h9.091a1.24 1.24 0 0 0 1.24-1.24V7.025a1.24 1.24 0 0 0-1.24-1.24h-1.24V3.949a1.86 1.86 0 1 1 3.719-.023v2.066a.618.618 0 0 0 .62.62h.826a.618.618 0 0 0 .62-.62V3.926A3.93 3.93 0 0 0 10.938 0z"
      style={{ fill: '#000' }}
    />
  </svg>
);

export const SvgSendMessage = ({ disabled }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 51 32">
    <g data-name="Groupe 8837" transform="translate(-1264 -966)">
      <rect
        data-name="Rectangle 10468"
        width="100%"
        height="100%"
        rx="5"
        transform="translate(1264 966)"
        style={{ fill: disabled ? 'rgb(172 169 183)' : '#5833ff' }}
      />
      <path
        data-name="Icon ionic-ios-send"
        d="M24.917 4.55 4.764 13.334a.462.462 0 0 0 .016.84l5.451 3.08a.879.879 0 0 0 1-.1l10.755-9.266c.071-.06.242-.176.307-.11s-.038.236-.1.307l-9.3 10.475a.876.876 0 0 0-.088 1.049l3.563 5.715a.464.464 0 0 0 .834-.011l8.336-20.154a.462.462 0 0 0-.621-.609z"
        transform="translate(1274.497 968.516)"
        style={{ fill: '#fff' }}
      />
    </g>
  </svg>
);

export const SvgPolygone = ({ hide }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 11 10"
    style={{ transform: hide ? 'rotate(270deg)' : 'initial' }}
  >
    <path data-name="Polygone 14" d="M5.5 0 11 10H0z" transform="rotate(180 5.5 5)" style={{ fill: '#000' }} />
  </svg>
);

export const SvgWomenBulle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 394.001 275.055">
    <path
      data-name="Union 23"
      d="M184.315 155H24.426a16.5 16.5 0 0 1-16.5-16.5v-209a16.5 16.5 0 0 1 16.5-16.5h361a16.5 16.5 0 0 1 16.5 16.5v209a16.5 16.5 0 0 1-16.5 16.5H210.267l-25.953 33.054z"
      transform="translate(-7.925 87)"
      style={{ fill: '#1a1a1a', opacity: '.9' }}
    />
  </svg>
);

export const SvgEchangeDisabled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 413.272 367.189">
    <g data-name="Groupe 8867">
      <g data-name="Groupe 8864">
        <path
          data-name="Tracé 9978"
          d="M50.957 55.411c-70.338 54.607-83.476 151.81 62.341 244.332s322.013-30.837 297.71-192.752S121.3.806 50.957 55.411z"
          transform="rotate(180 206.635 174.675)"
          style={{ fill: '#927aff' }}
        />
        <g data-name="Groupe 8860" transform="translate(-108.104)">
          <circle
            data-name="Ellipse 4942"
            cx="37.234"
            cy="37.234"
            transform="translate(273.83)"
            style={{ fill: '#6c63ff' }}
            r="37.234"
          />
          <path
            data-name="Tracé 10168"
            d="M907.336 260.565h-30.851a2.13 2.13 0 0 1-2.128-2.128V239.82a2.13 2.13 0 0 1 2.128-2.128h30.851a2.13 2.13 0 0 1 2.128 2.128v18.617a2.13 2.13 0 0 1-2.128 2.128zm-30.851-20.745v18.617h30.852V239.82z"
            transform="translate(-580.847 -207.107)"
            style={{ fill: '#fff' }}
          />
          <path
            data-name="Tracé 10169"
            d="M910.087 221.47h-19.149v-8.511c0-6.164 4.027-10.638 9.574-10.638s9.574 4.474 9.574 10.638zm-17.021-2.128h14.894v-6.383c0-5.011-3.062-8.511-7.447-8.511s-7.447 3.5-7.447 8.511z"
            transform="translate(-589.448 -188.756)"
            style={{ fill: '#fff' }}
          />
          <circle
            data-name="Ellipse 4943"
            cx="2.128"
            cy="2.128"
            transform="translate(308.937 39.361)"
            style={{ fill: '#fff' }}
            r="2.128"
          />
        </g>
      </g>
      <g data-name="Groupe 8861" transform="translate(.009 87.36)">
        <path
          data-name="Tracé 10205"
          d="M687.166 218.224a2.233 2.233 0 0 0 1.618-3.871l-.153-.608.061-.146a6 6 0 0 1 11.062.041c1.809 4.358 4.113 8.723 4.68 13.33a17.744 17.744 0 0 1-.312 6.1 71.129 71.129 0 0 0 6.47-29.542 68.639 68.639 0 0 0-.426-7.659q-.353-3.127-.979-6.21a71.953 71.953 0 0 0-14.269-30.5 19.149 19.149 0 0 1-7.964-8.263 14.607 14.607 0 0 1-1.328-3.991c.388.051 1.462-5.854 1.169-6.216.54-.82 1.507-1.227 2.1-2.028 2.935-3.979 6.978-3.284 9.089 2.123 4.509 2.276 4.553 6.05 1.786 9.68-1.76 2.309-2 5.434-3.547 7.907.159.2.324.4.483.6a72.414 72.414 0 0 1 7.559 11.975 30.106 30.106 0 0 1 1.8-13.983c1.72-4.15 4.945-7.645 7.784-11.233a6.179 6.179 0 0 1 11.006 3.034l.017.159q-.632.357-1.239.758a3.029 3.029 0 0 0 1.221 5.512l.062.01a30.13 30.13 0 0 1-.794 4.506c3.643 14.088-4.222 19.219-15.451 19.449-.248.127-.489.254-.737.375a73.918 73.918 0 0 1 3.979 18.724 70.1 70.1 0 0 1-.051 11.32l.019-.133a18.525 18.525 0 0 1 6.324-10.7c4.867-4 11.743-5.47 16.993-8.684a3.477 3.477 0 0 1 5.325 3.382l-.021.14a20.344 20.344 0 0 0-2.282 1.1q-.633.357-1.239.758a3.029 3.029 0 0 0 1.221 5.512l.062.009.127.019a30.164 30.164 0 0 1-5.549 8.688c-2.278 12.3-12.061 13.465-22.525 9.883h-.006a73.9 73.9 0 0 1-4.964 14.491h-17.736c-.064-.2-.121-.4-.178-.6a20.15 20.15 0 0 0 4.907-.292c-1.316-1.614-2.631-3.242-3.947-4.856a1.1 1.1 0 0 1-.083-.1c-.667-.826-1.341-1.646-2.008-2.472a29.512 29.512 0 0 1 .865-7.518z"
          transform="translate(-464.247 -133.948)"
          style={{ fill: '#fff' }}
        />
        <path
          data-name="Tracé 10206"
          d="M805.522 198.724c-3.3-12.021 23.3-22.33 30.28-12.649.971-1.376 4.56-2.212 6.206-1.79a12.841 12.841 0 0 1 4.382 2.5 17.308 17.308 0 0 1 4.923 4.957c1.148 2.043 1.326 4.83-.219 6.6-1.224 1.41-4.838 2.322-6.679 2.694a88.827 88.827 0 0 1-3.293.625 6.3 6.3 0 0 1-1.1-4.163 5.11 5.11 0 0 0-2.229 3.749c-.025.312 10.378 38.589 10.378 38.589a22.694 22.694 0 0 1-3.926 1.765 49.37 49.37 0 0 1-6.122-13.341 42.754 42.754 0 0 0 .118 9.5 52.3 52.3 0 0 0 .9 5.261c-12.362 2.668-30.956 1.79-39.045-9.559v-.141a1.931 1.931 0 0 0-3.731-.673c-.2.5-.377.934-.538 1.279-2.363-8.427.685-18.18 9.695-35.203z"
          transform="translate(-525.668 -159.831)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10207"
          d="M770.948 679.207v.394a1.675 1.675 0 0 1 0-.394z"
          transform="translate(-512.13 -438.771)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10208"
          d="M798.558 523.895a6.707 6.707 0 0 1 .958-.186q-.557.091-.958.186z"
          transform="translate(-527.634 -351.492)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10209"
          d="M797.919 524.2c.085-.024.18-.048.28-.071-.093.028-.184.046-.28.071z"
          transform="translate(-527.275 -351.729)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10210"
          d="M870.8 627.731h-45.311a3.6 3.6 0 0 1-.97-4.438c1.238-2.839-1.188-5.433-1.188-5.433a7.707 7.707 0 0 1-1.553-7.1c1.2-4.193-3.5-16.028-3.5-16.028s-2.536 15.282-5.644 33h-43.099a8.011 8.011 0 0 1 0-8.111c2.511-4.258 0-5.075 0-5.075s-2.511-4.765 0-8.225 0-17.587 0-17.587c.095.625.81-.511 1.912-2.892 1.677-3.623 4.24-10.138 6.829-17.7 1.851-5.4 3.717-11.338 5.277-17.145q.613-2.288 1.162-4.535c.716-2.938 1.329-5.792 1.794-8.472 1.011-5.773 1.344-10.732.568-13.957-.644-2.684-2.052-4.164-4.482-3.91 1.3-.216 3.21-.42 5.561-.613.424-.034.863-.068 1.317-.106 17.535-1.325 55.155-2.086 55.155-2.086l11.523 20.635 14.593 26.139s-.395 35.062.056 63.639z"
          transform="translate(-510.717 -347.903)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10211"
          d="m824.456 306.815-26.548-5.632-5.271 10.61-17.751 10.277s11.442 46.785 11.377 53.365c-.166 16.706-26.9 54.154-6.706 51.274s24.291-14.948 30.773-13.04c5.845 1.721 12.983 9.376 17.761 3.9s6.462.847 9.483 1.066c1.436.1.571-6.914 4.184.218s22.771-2.468 16.278-8.962c-10.814-10.814-13.012-90.533-13.012-90.533l-12.039-3.7z"
          transform="translate(-512.737 -226.59)"
          style={{ fill: '#21ffcf' }}
        />
        <path
          data-name="Tracé 10212"
          d="M763.553 653.467a6.373 6.373 0 0 0-.656-8.864 6.106 6.106 0 0 0-.819-.593l4.439-21.785-10.262-6.142-2.854 30.5a6.355 6.355 0 0 0 1.465 7.619 6.082 6.082 0 0 0 8.579-.608q.055-.062.108-.127z"
          transform="translate(-501.906 -403.341)"
          style={{ fill: '#a0616a' }}
        />
        <path
          data-name="Tracé 10213"
          d="M794.868 381.839c-.064-.7-.958-1.018-2.2-1.457a13.578 13.578 0 0 1-3.509-1.662c-2.741-1.98-1.662-4.051-.17-6.912.292-.556.594-1.136.878-1.738.844-1.783-.5-9.138-4-21.865-1.079-3.918-1.075-6.685-1.821-8.521s-2.23-2.741-6.284-2.93a18.536 18.536 0 0 0-13.344 4.743c-.1.087-.2.182-.3.273q-.278.261-.545.534a18.522 18.522 0 0 0-5.383 12.734l-.019.814-.836 38.885-2.351 34.123-3.24 47 2.4.117 9.577.477 1.162.057 2.756-11.561 3.316-13.912 1.219-5.111 3.782-15.854 1.764-7.408 1.079-4.524.439-1.847 2.143-8.979c.049-.189 4.978-19.636 10.66-22.887 2.123-1.207 2.887-1.911 2.827-2.589z"
          transform="translate(-501.359 -246.542)"
          style={{ fill: '#21ffcf' }}
        />
        <path
          data-name="Tracé 10214"
          d="M987.292 652.213a6.373 6.373 0 0 1-.3-8.883 6.11 6.11 0 0 1 .75-.677l-6.752-21.183 9.543-7.208 6.113 30.017a6.355 6.355 0 0 1-.638 7.732 6.082 6.082 0 0 1-8.6.317z"
          transform="translate(-630.031 -402.318)"
          style={{ fill: '#a0616a' }}
        />
        <path
          data-name="Tracé 10215"
          d="M943.72 453.124s-7.444-26.186-5.175-29.021-4.434-3.388-1.545-8.668-1.1-6.162-1.1-6.162l-2.164-12.139-3.868-29.815-.117-.887-1.125-8.674A18.576 18.576 0 0 0 921.3 345.2c-.1-.078-.207-.153-.311-.229q-.714-.514-1.46-.953a18.541 18.541 0 0 0-12.329-2.338c-8.022 1.249-5.525 4.241-6.826 12.255-2.114 13.031-2.663 20.486-1.632 22.171.347.567.712 1.11 1.06 1.631 1.791 2.689 3.086 4.629.572 6.9a13.707 13.707 0 0 1-3.31 2.025c-1.181.572-2.037.983-2.025 1.686.013.681.849 1.3 3.085 2.272 2.71 1.186 5.62 5.67 8 10.25a113.118 113.118 0 0 1 5.053 11.362l20.49 57.627 3.342 9.4 1.153-.182 9.467-1.5 2.374-.376z"
          transform="translate(-581.788 -249.192)"
          style={{ fill: '#21ffcf' }}
        />
        <circle
          data-name="Ellipse 4953"
          cx="21.659"
          cy="21.659"
          r="21.659"
          transform="translate(278.86 30.876)"
          style={{ fill: '#a0616a' }}
        />
        <path
          data-name="Tracé 10216"
          d="M778.576 202.574c-3.3-12.021 23.3-22.33 30.28-12.649.971-1.376 4.56-2.212 6.206-1.79a12.841 12.841 0 0 1 4.382 2.5 17.308 17.308 0 0 1 4.923 4.957c1.148 2.043 1.326 4.83-.22 6.6-1.224 1.41-4.838 2.322-6.679 2.694a88.436 88.436 0 0 1-3.293.625 6.3 6.3 0 0 1-1.1-4.163 5.111 5.111 0 0 0-2.229 3.749c-.025.312 10.378 38.589 10.378 38.589a22.7 22.7 0 0 1-3.926 1.765 49.375 49.375 0 0 1-6.122-13.341 42.757 42.757 0 0 0 .118 9.5 52.266 52.266 0 0 0 .9 5.261c-12.362 2.668-30.956 1.79-39.045-9.559v-.141a1.931 1.931 0 0 0-3.731-.673c-.2.5-.377.934-.538 1.279-2.362-8.427.686-18.177 9.696-35.203z"
          transform="translate(-510.543 -161.992)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10218"
          d="M478.809 289.223a2.233 2.233 0 0 1-1.618-3.871l.153-.608-.061-.146a6 6 0 0 0-11.062.041c-1.809 4.358-4.113 8.723-4.68 13.33a17.742 17.742 0 0 0 .311 6.1 71.131 71.131 0 0 1-6.47-29.542 68.655 68.655 0 0 1 .426-7.659q.353-3.127.979-6.21a71.952 71.952 0 0 1 14.269-30.5 19.149 19.149 0 0 0 7.964-8.263 14.607 14.607 0 0 0 1.328-3.992c-.388.051-1.462-5.854-1.169-6.216-.54-.82-1.507-1.227-2.1-2.027-2.935-3.979-6.978-3.284-9.089 2.123-4.509 2.276-4.553 6.05-1.786 9.68 1.76 2.309 2 5.434 3.547 7.907-.159.2-.324.4-.483.6a72.424 72.424 0 0 0-7.559 11.975 30.1 30.1 0 0 0-1.8-13.983c-1.72-4.15-4.945-7.645-7.784-11.233a6.179 6.179 0 0 0-11.006 3.034l-.017.159q.633.357 1.239.758a3.029 3.029 0 0 1-1.221 5.512l-.062.01a30.131 30.131 0 0 0 .794 4.506c-3.643 14.088 4.222 19.219 15.451 19.449.248.127.489.254.737.375a73.914 73.914 0 0 0-3.979 18.724 70.11 70.11 0 0 0 .051 11.32l-.019-.133a18.525 18.525 0 0 0-6.324-10.7c-4.867-4-11.743-5.47-16.993-8.684a3.477 3.477 0 0 0-5.325 3.382l.021.14a20.35 20.35 0 0 1 2.282 1.1q.633.357 1.239.758a3.029 3.029 0 0 1-1.221 5.512l-.062.01-.127.019a30.169 30.169 0 0 0 5.549 8.688c2.278 12.3 12.061 13.465 22.525 9.883h.006a73.9 73.9 0 0 0 4.964 14.491h17.733c.064-.2.121-.4.178-.6a20.149 20.149 0 0 1-4.907-.292c1.316-1.614 2.631-3.242 3.947-4.856a1.1 1.1 0 0 0 .083-.1c.667-.826 1.341-1.646 2.008-2.472a29.512 29.512 0 0 0-.865-7.518z"
          transform="translate(-318.192 -173.799)"
          style={{ fill: '#fff' }}
        />
        <path
          data-name="Tracé 10219"
          d="M340.4 190.979c-.4.938-12.812.837-13.381 1.673-4.382 6.448 11.415 33.881 7.032 40.338l-.61.728a28.846 28.846 0 0 0 4.106-2.317c.117-2.643.234-5.294.36-7.936a21.812 21.812 0 0 1 3.144 5.528 35.8 35.8 0 0 1 6.23-4.675 27.426 27.426 0 0 1 6.06-4.989z"
          transform="translate(-262.53 -164.734)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10220"
          d="M267.885 309.3a10.278 10.278 0 0 0-15.571 6.08l-18.858 49.137-32.415-18.4a10.036 10.036 0 1 0-6.261 9.982c6.826 7.286 36.421 37.157 48.673 25.486 10.3-9.81 25.16-47.832 28.738-60.962a10.279 10.279 0 0 0-4.306-11.323z"
          transform="translate(-181 -230.21)"
          style={{ fill: '#ffb6b6' }}
        />
        <path
          data-name="Tracé 10221"
          d="m117.341 349.883 5.951 26.9 43.517 3.936 4-23.421z"
          transform="translate(-65.867 -196.455)"
          style={{ fill: '#ffb6b6' }}
        />
        <path
          data-name="Tracé 10222"
          d="M327.8 572.992c-.02.386-.044.767-.072 1.153-.417 5.573-.894 12-1.411 19.046a9692.45 9692.45 0 0 0-2.644 37.225H232.4l17.7-53.208s7.148-3.935 3.509-10.546 3.521-1.343 3.588-10.784 6.483-19.486 6.483-19.486l1.053-14.3.6.012 47.5.791.867.016 1.459 12.272a54.254 54.254 0 0 1 12.641 37.809z"
          transform="translate(-209.854 -350.586)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10223"
          d="m322.585 280.288 21.66-1.116 10.061 15.9s18.929 3.165 17.617 25.471-23.031 41.879-23.031 41.879l.928-3.183-1.612 4.607.207 2.587 2.2 2.74.225 2.827-1.949 4.483a2.562 2.562 0 0 1-2.429 3.9l-31.3-3.137c-.713-1.96-1.284-4.305-4.141-.4l-2.948-.286-12.256-1.187-.721-2.628a10.18 10.18 0 0 1 1.656-8.781 13.428 13.428 0 0 1 .777-10.082l.059-.117 1.3-1.085S284.654 331.3 301 315.184l6.561-11.153 7.341-8.956z"
          transform="translate(-243.951 -214.236)"
          style={{ fill: '#175df9' }}
        />
        <circle
          data-name="Ellipse 4954"
          cx="20.54"
          cy="20.54"
          r="20.54"
          transform="translate(63.485 15.588)"
          style={{ fill: '#ffb6b6' }}
        />
        <path
          data-name="Tracé 10224"
          d="M351.377 207.005a9.892 9.892 0 0 1-3.312-5.436 21.253 21.253 0 0 0 .293 7.761 131.585 131.585 0 0 1-3.211 2.35 21.814 21.814 0 0 0-3.147-5.528c-.125 2.643-.243 5.294-.36 7.936a28.847 28.847 0 0 1-4.106 2.317l.611-.728c4.382-6.456-6.958-18.34-2.576-24.788 1.229-1.806-4.324-16.082-8.555-16.726-3.763-.569-3.6.518-7.251 1.313a18.245 18.245 0 0 0-1.748-4.524 14.949 14.949 0 0 1-.142 4.767c-1.3.05-2.316-.776-3.7-.987-8.806-1.346-7.911-10.872-5.461-13.891s10.621-3.914 14.384-4.892c.343-.334 1.121-.125 1.464-.443 7.212-6.6 16.858-7.693 25.538-4.768 9.257 3.12 15.028 9.158 17.99 18.466l.85 7.449c.762 2.4-.2 13.54-.85 15.967-2.532 9.436-7.937 4.726-16.711 14.385z"
          transform="translate(-251.752 -141.288)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10225"
          d="m446.126 409.393-.809-62.978a10.166 10.166 0 0 0-10.165-10.006A10.166 10.166 0 0 0 425 347.115l2.845 65.393.054 39.808a8.871 8.871 0 1 0 10.892 3.317z"
          transform="translate(-316.552 -246.363)"
          style={{ fill: '#ffb6b6' }}
        />
        <path
          data-name="Tracé 10226"
          d="M596.919 642s-1.25 22.493-1.825 35.321h-43.055c-.886-11.674-1.184-20.251-1.184-20.251l-2.355 20.25h-43.52l-2.7-37.505 13.038-32.32s70.659-4.9 77.213 1.316S596.919 642 596.919 642z"
          transform="translate(-361.336 -397.49)"
          style={{ fill: '#2f2e41' }}
        />
        <circle
          data-name="Ellipse 4955"
          cx="23.518"
          cy="23.518"
          r="23.518"
          transform="translate(173.992 8.263)"
          style={{ fill: '#ffb6b6' }}
        />
        <path
          data-name="Tracé 10227"
          d="M624.656 155.137c-2.416 1.1-3.981 9.079-5.879 7.224s-1.772-4.268-4.332-4.952a8.676 8.676 0 0 0-6.177 1.08 20.53 20.53 0 0 0-.981.559 8.369 8.369 0 0 0-.643-.394 7.473 7.473 0 0 0-5.5-.619 7.331 7.331 0 0 1 3.623 2.671c-.631.423-1.27.847-1.924 1.223-5.462 3.152-13.234-3.7-18.983-6.277 3.6 6.758 1.828 9.557-1.3 16.546l-.108.4c.178-1.752-5.243-3.057-4.928-.591a29.689 29.689 0 0 0 2.587 7.188c-6.045-6.989-10.176-15.543-9.3-24.366.19-1.854.133-3.809 1.089-5.418s2.952-2.724 4.717-2.113a15.593 15.593 0 0 1 23.474-14.269 59.589 59.589 0 0 1 6.21 4.813c2.069 1.616 4.453 3.024 7.077 3.157 1.664.08 3.475-.326 4.9.536 1.656 1 1.94 3.094 2.188 5.109a7.464 7.464 0 0 0-4.022 1.674 7.3 7.3 0 0 1 4.4.943.453.453 0 0 1 .072.041c.873 3.327.784 4.065 3.74 5.835z"
          transform="translate(-399.734 -130.998)"
          style={{ fill: '#2f2e41' }}
        />
        <path
          data-name="Tracé 10228"
          d="M508.668 426.453c20.028-23.443 13.263-53.259 5.314-83.359l1.513-44.465a13.6 13.6 0 0 1 6.155-10.925l20.445-13.357 7.958-11.506 21.935 2.194 12.164 12.865 13.464 10.279a22.305 22.305 0 0 1 8.244 22.545l-12.885 58.27s5.389 30.208 2.1 33.544-11.761 0-5.042 3.747c8.063 4.494 15.4 3.665 11.315 7.746s1.084 9.754 1.084 9.754z"
          transform="translate(-364.922 -205.07)"
          style={{ fill: '#5833ff' }}
        />
        <path
          data-name="Tracé 10229"
          d="m508.706 678.137 3.339-23.787-13.322-3.8-2.635 25.275a8.041 8.041 0 1 0 12.619 2.315z"
          transform="translate(-356.397 -422.684)"
          style={{ fill: '#ffb6b6' }}
        />
        <path
          data-name="Tracé 10230"
          d="M530.432 298.842s-37.921 12.342-38.826 21.373-.6 14.559-4.607 50.7l.211 97.342s25.424 5.443 22.817-.377-1.7-8.558-1.7-8.558 5.451-2.151 4.086-8.985 5.478-40.7 5.478-40.7l4.319-60.735z"
          transform="translate(-352.76 -225.276)"
          style={{ fill: '#5833ff' }}
        />
        <path
          data-name="Tracé 10231"
          d="m690.308 676.176-1.777-23.955 13.543-2.924.977 25.393a8.041 8.041 0 1 1-12.743 1.486z"
          transform="translate(-465.877 -421.983)"
          style={{ fill: '#ffb6b6' }}
        />
        <path
          data-name="Tracé 10232"
          d="M661.99 293.078s37.034 14.795 37.346 23.865-.349 14.567 1.283 50.888l-6.573 97.12s-25.725 3.77-22.743-1.867 2.253-8.429 2.253-8.429-5.3-2.5-3.49-9.232-2.806-40.969-2.806-40.969l-.34-60.887z"
          transform="translate(-450.98 -222.041)"
          style={{ fill: '#5833ff' }}
        />
      </g>
    </g>
  </svg>
);

export const SvgWomenEchange = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 218.629 480">
    <g data-name="Groupe 8862" transform="translate(-61.343 -762.585)">
      <path
        data-name="Tracé 10206"
        d="M814.572 212.975c-6.148-22.416 43.441-41.639 56.463-23.587 1.811-2.566 8.5-4.125 11.573-3.338s5.653 2.755 8.172 4.661c3.464 2.661 7.054 5.416 9.18 9.242 2.141 3.81 2.472 9.006-.409 12.313-2.283 2.629-9.022 4.33-12.455 5.023-2.393.488-4.409.882-6.141 1.165a11.741 11.741 0 0 1-2.047-7.763 9.528 9.528 0 0 0-4.157 6.991c-.047.583 19.351 71.957 19.351 71.957a42.313 42.313 0 0 1-7.322 3.291 92.057 92.057 0 0 1-11.415-24.878 79.713 79.713 0 0 0 .22 17.714 97.506 97.506 0 0 0 1.669 9.809c-23.051 4.976-57.723 3.338-72.807-17.824q0-.131-.008-.263a3.6 3.6 0 0 0-6.956-1.256c-.366.934-.7 1.742-1 2.385-4.395-15.717 1.289-33.899 18.089-65.642z"
        transform="translate(-698.284 580.342)"
        style={{ fill: '#2f2e41' }}
      />
      <path
        data-name="Tracé 10210"
        d="M959.33 723.207h-84.494a6.719 6.719 0 0 1-1.809-8.275c2.308-5.294-2.215-10.131-2.215-10.131a14.37 14.37 0 0 1-2.9-13.245c2.239-7.819-6.534-29.888-6.534-29.888s-4.729 28.5-10.525 61.539H770.5a14.937 14.937 0 0 1 0-15.125c4.683-7.941 0-9.463 0-9.463s-4.683-8.885 0-15.337 0-32.795 0-32.795c.176 1.165 1.51-.953 3.565-5.393 3.127-6.755 7.906-18.9 12.734-33.007 3.452-10.066 6.932-21.141 9.84-31.969h.007q1.144-4.267 2.167-8.456c1.334-5.478 2.478-10.8 3.346-15.8 1.885-10.765 2.506-20.012 1.059-26.026-1.2-5-3.826-7.765-8.358-7.292 2.428-.4 5.986-.784 10.369-1.143.791-.064 1.609-.127 2.457-.2 32.7-2.471 102.847-3.889 102.847-3.889l21.487 38.478 27.212 48.741s-.744 65.389.098 118.676z"
        transform="translate(-693.439 519.379)"
        style={{ fill: '#262626' }}
      />
      <path
        data-name="Tracé 10211"
        d="m869.8 311.684-49.5-10.5-9.829 19.785-33.1 19.164s21.329 87.237 21.21 99.507c-.309 31.151-50.152 100.981-12.5 95.61s45.3-27.874 57.381-24.316c10.9 3.209 24.209 17.484 33.119 7.274s12.049 1.58 17.683 1.987c2.678.194 1.065-12.892 7.8.407s42.461-4.6 30.353-16.711c-20.165-20.165-24.263-168.816-24.263-168.816l-22.454-6.906z"
        transform="translate(-694.093 558.702)"
        style={{ fill: '#21ffcf' }}
      />
      <path
        data-name="Tracé 10212"
        d="M772.919 685.792a11.883 11.883 0 0 0-1.224-16.529 11.38 11.38 0 0 0-1.526-1.105l8.277-40.622-19.135-11.452-5.322 56.873a11.85 11.85 0 0 0 2.731 14.207 11.341 11.341 0 0 0 16-1.134q.1-.117.199-.238z"
        transform="translate(-690.581 501.406)"
        style={{ fill: '#a0616a' }}
      />
      <path
        data-name="Tracé 10213"
        d="M832.154 420.844c-.12-1.306-1.786-1.9-4.094-2.718a25.323 25.323 0 0 1-6.543-3.1c-5.111-3.692-3.1-7.553-.318-12.889a87.178 87.178 0 0 0 1.638-3.24c1.574-3.325-.932-17.04-7.461-40.772-2.012-7.306-2-12.466-3.4-15.889s-4.158-5.111-11.718-5.464a34.564 34.564 0 0 0-24.882 8.845c-.183.162-.374.339-.558.508q-.519.487-1.017 1a34.538 34.538 0 0 0-10.038 23.746l-.035 1.518-1.56 72.508-4.384 63.628-6.042 87.649 4.475.219 17.858.89 2.167.106 5.139-21.558 6.183-25.941 2.273-9.53 7.063-29.56 3.289-13.814 2.012-8.435.818-3.445 4-16.744c.092-.353 9.283-36.614 19.878-42.678 3.944-2.263 5.37-3.576 5.257-4.84z"
        transform="translate(-690.404 552.232)"
        style={{ fill: '#21ffcf' }}
      />
      <path
        data-name="Tracé 10214"
        d="M992.741 685.029a11.883 11.883 0 0 1-.559-16.565 11.39 11.39 0 0 1 1.4-1.263L980.99 627.7l17.794-13.441 11.4 55.972a11.85 11.85 0 0 1-1.19 14.418 11.341 11.341 0 0 1-16.027.591q-.114-.102-.226-.211z"
        transform="translate(-732.113 501.739)"
        style={{ fill: '#a0616a' }}
      />
      <path
        data-name="Tracé 10215"
        d="M985.812 549.687s-13.882-48.828-9.649-54.115-8.268-6.318-2.881-16.163-2.048-11.491-2.048-11.491l-4.034-22.634-7.212-55.6-.219-1.653-2.1-16.175a34.638 34.638 0 0 0-13.658-23.41 23.965 23.965 0 0 0-.58-.426q-1.332-.959-2.722-1.777a34.574 34.574 0 0 0-22.993-4.367c-14.959 2.33-10.3 7.908-12.729 22.852-3.942 24.3-4.965 38.2-3.043 41.342.647 1.058 1.328 2.07 1.977 3.041 3.34 5.014 5.755 8.631 1.067 12.858a25.557 25.557 0 0 1-6.172 3.776c-2.2 1.067-3.8 1.832-3.776 3.143.025 1.27 1.582 2.418 5.752 4.237 5.053 2.211 10.48 10.572 14.926 19.113a210.908 210.908 0 0 1 9.422 21.187l38.207 107.457 6.232 17.524 2.15-.34 17.654-2.8 4.427-.7z"
        transform="translate(-716.476 551.376)"
        style={{ fill: '#21ffcf' }}
      />
      <circle
        data-name="Ellipse 4953"
        cx="40.388"
        cy="40.388"
        r="40.388"
        transform="translate(114.434 778.368)"
        style={{ fill: '#a0616a' }}
      />
      <path
        data-name="Tracé 10216"
        d="M787.626 216.825c-6.148-22.416 43.441-41.638 56.463-23.587 1.811-2.566 8.5-4.125 11.573-3.338s5.653 2.755 8.172 4.661c3.464 2.661 7.054 5.416 9.179 9.243 2.141 3.81 2.472 9.006-.409 12.313-2.283 2.629-9.022 4.33-12.455 5.023-2.393.488-4.409.882-6.141 1.165a11.741 11.741 0 0 1-2.047-7.762 9.529 9.529 0 0 0-4.157 6.991c-.047.583 19.351 71.957 19.351 71.957a42.322 42.322 0 0 1-7.322 3.291 92.073 92.073 0 0 1-11.414-24.882 79.733 79.733 0 0 0 .22 17.714 97.476 97.476 0 0 0 1.669 9.809c-23.051 4.976-57.723 3.338-72.807-17.824 0-.088-.005-.175-.008-.263a3.6 3.6 0 0 0-6.956-1.256c-.366.934-.7 1.742-1 2.385-4.395-15.711 1.289-33.898 18.089-65.64z"
        transform="translate(-693.382 579.639)"
        style={{ fill: '#2f2e41' }}
      />
    </g>
  </svg>
);

export const SvgLogoSmallLoader = () => (
  <svg css={SC.bounce} id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.55 48.82">
    <circle cx="22.27" cy="24.59" r="2.81" style={{ fill: '#ffd166', strokeWidth: 0 }} />
    <path
      d="m2.37,18.45c0,7.86,0,17.33,0,21.91,0,4.98,2.43,8.19,5.48,8.24.03,0,.06,0,.09,0,1.54,0,2.52-.6,3.32-1.46,1.45-1.55,2.25-4.1,2.25-6.74v-11.11c-4.48-1.86-8.66-6.03-11.14-10.85Z"
      style={{ fill: '#364ebf', strokeWidth: 0 }}
    />
    <path
      d="m20.93,29.31c-.08-.33-.48-.51-.79-.62-3.08-.91-4.82-3.5-5.04-6.76-.8-6.29,1.71-14.36-3.13-19.52C8.69-.93,3.1.11,1.12,4.29c-4.94,10.6,7.38,27.58,18.9,25.9.44-.07,1.01-.38.91-.86v-.03Z"
      style={{ fill: '#2fd7ca', strokeWidth: 0 }}
    />
    <path
      d="m42.19,30.58c0-7.86,0-17.33,0-21.91,0-4.98-2.43-8.19-5.48-8.24-.03,0-.06,0-.09,0-1.54,0-2.52.6-3.32,1.46-1.45,1.55-2.25,4.1-2.25,6.74v11.11c4.48,1.86,8.66,6.03,11.14,10.85Z"
      style={{ fill: '#364ebf', strokeWidth: 0 }}
    />
    <path
      d="m23.73,19.95c.19.22.52.33.8.43,2.98.88,4.73,3.52,4.93,6.69.77,6.06-1.5,13.63,2.55,18.91,3.15,4.06,9.39,3.24,11.48-1.38,4.74-10.67-7.35-27.25-18.88-25.77-.55.04-1.35.48-.9,1.09l.02.02Z"
      style={{ fill: '#2fd7ca', strokeWidth: 0 }}
    />
  </svg>
);

export const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" width="100%" height="100%">
    <circle css={SC.circleFill} cx="27" cy="27" r="27" fill="#262626" />
    <g>
      <g>
        <path
          css={[SC.pathFill, SC.pathStroke]}
          fill="#ffffff"
          d="M23.564 22.161l-6.784-6.783a9.461 9.461 0 1 0-1.405 1.405l6.784 6.784a.994.994 0 1 0 1.405-1.405zM9.443 16.9A7.455 7.455 0 1 1 16.9 9.446 7.463 7.463 0 0 1 9.443 16.9z"
          transform="translate(15.072 15.07) translate(0 .003) translate(0 -.003)"
        />
      </g>
    </g>
  </svg>
);

export const CollectionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" width="100%" height="100%">
    <g id="Collection" transform="translate(-176 -59)">
      <circle css={SC.circleFill} id="Ellipse_4713" cx="27" cy="27" r="27" fill="#262626" transform="translate(176 59)" />
      <g>
        <path
          css={[SC.pathFill, SC.pathStroke]}
          id="Tracé_2799"
          d="M4608.5-1165.5v21.5"
          fill="#21ffcf"
          stroke="#21ffcf"
          strokeLinecap="round"
          strokeWidth="2px"
          transform="translate(-4417.282 1240.75)"
        />
        <path
          css={[SC.pathFill, SC.pathStroke]}
          id="Tracé_2800"
          d="M4608.5-1165.5v21.5"
          fill="#21ffcf"
          stroke="#21ffcf"
          strokeLinecap="round"
          strokeWidth="2px"
          transform="translate(-4411.282 1240.75)"
        />
        <path
          css={[SC.pathFill, SC.pathStroke]}
          id="Tracé_2801"
          d="M4608.5-1165.5v21.5"
          fill="#21ffcf"
          stroke="#21ffcf"
          strokeLinecap="round"
          strokeWidth="2px"
          transform="translate(-4405.282 1240.75)"
        />
        <path
          css={[SC.pathFill, SC.pathStroke]}
          id="Tracé_2802"
          d="M4608.5-1165.5v21.5"
          fill="#21ffcf"
          stroke="#21ffcf"
          strokeLinecap="round"
          strokeWidth="2px"
          transform="rotate(-15 7123.843 16163)"
        />
      </g>
    </g>
  </svg>
);

export const ShopIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54" width="100%" height="100%">
    <g id="Groupe_641" transform="translate(0 -8)">
      <circle css={SC.circleFill} id="Ellipse_4713" cx="27" cy="27" r="27" fill="#262626" transform="translate(0 8)" />
      <g id="Icon_feather-shopping-cart" transform="translate(12.086 21.945)">
        <path
          css={SC.pathStroke}
          id="Tracé_2884"
          d="M14.219 31.11A1.11 1.11 0 1 1 13.11 30a1.11 1.11 0 0 1 1.109 1.11z"
          fill="none"
          stroke="#21ffcf"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2px"
          transform="translate(-2.732 -7.415)"
        />
        <path
          css={SC.pathStroke}
          id="Tracé_2885"
          d="M30.719 31.11A1.11 1.11 0 1 1 29.61 30a1.11 1.11 0 0 1 1.109 1.11z"
          fill="none"
          stroke="#21ffcf"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2px"
          transform="translate(-7.025 -7.415)"
        />
        <path
          css={SC.pathStroke}
          id="Tracé_2886"
          d="M1.5 1.5h4.439l2.974 14.859a2.219 2.219 0 0 0 2.219 1.787h10.787a2.219 2.219 0 0 0 2.219-1.787l1.776-9.311H7.049"
          fill="none"
          stroke="#21ffcf"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2px"
        />
      </g>
    </g>
  </svg>
);

export const MySvgAcademy = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="3.3755rem" height="3.3755rem" viewBox="0 0 54 54">
    <defs>
      <style>
        {`.a { fill: #ffffff; }
        .b { fill: #14b3ff; }
        .c { fill: #1199ce; }
        .d { fill: #725fff; }
        .e { fill: #5833ff; }
        .f { fill: url(#a); }
        .g { fill: #21ffcf; }
        .h { fill: #27e2b6; }`}
      </style>
      <linearGradient id="a" x1="0.212" y1="0.617" x2="1.078" y2="0.267" gradientUnits="objectBoundingBox">
        <stop offset="0.26" stopColor="#1d1d1b" stopOpacity="0" />
        <stop offset="1" />
      </linearGradient>
    </defs>
    <g transform="translate(-544 -92)">
      <circle className="a" cx="27" cy="27" r="27" transform="translate(544 92)" />
      <g transform="translate(139.963 17.165)">
        <g transform="translate(428.519 94.481)">
          <path
            className="b"
            d="M564.77,105.394l-.613-.981h-7.845l4.9,7.845h7.845Z"
            transform="translate(-556.312 -104.413)"
          />
          <path
            className="c"
            d="M619.337,192.7l-.613-.981h-7.845l2.129,3.407h0s2.381,4.438,5.1,4.438h5.516Z"
            transform="translate(-605.976 -183.875)"
          />
        </g>
        <path className="d" d="M483.218,93.5h-7.845l-4.9,7.845h7.845Z" transform="translate(-49.664)" />
        <path className="e" d="M428.651,180.807h-7.845l-4.9,7.845h7.845Z" transform="translate(0 -79.462)" />
        <path className="f" d="M515,93.5l-.991,1.586,3.933,6.259.981-1.569Z" transform="translate(-89.287)" />
        <path
          className="g"
          d="M530.757,94.481l-.613-.981H522.3l-.27.444s.319-.281.821.437h0l4.352,6.964h7.845Z"
          transform="translate(-96.59)"
        />
        <path
          className="h"
          d="M588.061,181.788l-.613-.981H579.6l2.129,3.407h0s2.381,4.438,5.1,4.438h5.516Z"
          transform="translate(-148.991 -79.462)"
        />
      </g>
    </g>
  </svg>
);

export const SvgInformer = ({ ...props }: SvgProps) => (
  <SC.Svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 66 66">
    <defs>
      <filter id="p5ysd93gya" width="66" height="66" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset />
        <feGaussianBlur result="blur" stdDeviation="2" />
        <feFlood floodOpacity=".878" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g>
      <g filter="url(#p5ysd93gya)" transform="translate(-783.479 -49.583) translate(783.48 49.58)">
        <circle cx="27" cy="27" r="27" fill="#21ffcf" transform="translate(6 6)" />
      </g>
      <g>
        <g>
          <path
            d="M16.085.022a16.128 16.128 0 0 0-1.728.093A15.2 15.2 0 0 0 12.8.364q-.149.031-.3.066a16.105 16.105 0 0 0-7.943 4.448q-.3.31-.591.637a16.123 16.123 0 0 0 23.651 21.9q.3-.31.591-.637A16.122 16.122 0 0 0 16.085.022zM5.273 5.684c.085-.088.173-.173.26-.258s.2-.2.3-.292.182-.164.274-.246.207-.184.313-.272.19-.155.285-.231.215-.172.326-.255.2-.145.3-.215.223-.161.336-.235.2-.135.307-.2.231-.146.347-.215.211-.124.317-.185.238-.134.358-.2.215-.113.322-.168c.123-.062.246-.121.37-.18.107-.051.219-.1.33-.15l.382-.161c.111-.046.222-.09.334-.133.13-.049.262-.1.393-.142l.339-.116c.134-.043.269-.083.4-.122l.34-.1.131-.032a13.335 13.335 0 0 0-3.43 5.579 18.051 18.051 0 0 1-3.682-1.417c.017-.019.032-.038.048-.054zm-.773.865a18.672 18.672 0 0 0 4.079 1.623 27.888 27.888 0 0 0-1.085 7.435H1.05A15.016 15.016 0 0 1 4.5 6.549zm0 19.192a15.018 15.018 0 0 1-3.45-9.058h6.444a27.886 27.886 0 0 0 1.085 7.435A18.685 18.685 0 0 0 4.5 25.741zm7.708 4.942c-.109-.027-.221-.063-.333-.1-.136-.04-.272-.08-.407-.123-.113-.037-.225-.076-.337-.115-.132-.046-.264-.092-.4-.142-.112-.042-.222-.087-.333-.132l-.384-.161q-.164-.073-.327-.149c-.125-.059-.25-.119-.376-.182-.107-.054-.215-.107-.322-.166s-.242-.132-.362-.2-.21-.121-.313-.183-.234-.144-.35-.219-.2-.131-.3-.2-.228-.158-.34-.239-.2-.141-.293-.215-.22-.17-.329-.257-.19-.151-.283-.229-.211-.182-.315-.275-.183-.161-.272-.244-.2-.2-.3-.293-.175-.17-.26-.257l-.046-.05A18.038 18.038 0 0 1 8.9 25.138a13.338 13.338 0 0 0 3.435 5.577c-.035-.015-.084-.02-.127-.032zm3.34.468c-2.3-.327-4.316-2.727-5.584-6.271a27.312 27.312 0 0 1 5.584-.657v6.929zm0-8a28.3 28.3 0 0 0-5.921.706 26.886 26.886 0 0 1-1.058-7.171h6.98v6.465zm0-7.54h-6.98a26.88 26.88 0 0 1 1.059-7.174 28.312 28.312 0 0 0 5.921.706zm0-7.54a27.283 27.283 0 0 1-5.584-.657c1.268-3.544 3.284-5.945 5.584-6.271v6.925zm12.123-1.522a15.018 15.018 0 0 1 3.45 9.058h-6.444a27.886 27.886 0 0 0-1.085-7.435 18.692 18.692 0 0 0 4.079-1.623zm-7.712-4.943c.113.028.225.063.337.1.136.04.272.08.407.123.113.037.225.076.337.115.132.046.264.092.4.142.112.042.222.087.333.132l.384.161q.164.073.327.149c.125.059.25.119.376.182.107.054.215.107.322.166s.242.132.362.2.21.121.313.183.234.144.35.219.2.131.3.2.227.157.34.238.2.141.295.215.219.17.328.257.19.15.283.229.211.182.315.275.183.161.272.244.2.2.3.293.175.17.26.257l.046.05a18.038 18.038 0 0 1-3.682 1.418 13.338 13.338 0 0 0-3.439-5.577c.046.008.09.017.134.029zm-3.336-.467c2.3.327 4.316 2.727 5.584 6.271a27.312 27.312 0 0 1-5.584.657V1.139zm0 8a28.3 28.3 0 0 0 5.921-.706 26.886 26.886 0 0 1 1.056 7.175h-6.98zm0 7.54H23.6a26.88 26.88 0 0 1-1.058 7.171 28.311 28.311 0 0 0-5.921-.706zm0 14.468v-6.925a27.283 27.283 0 0 1 5.584.657c-1.268 3.545-3.284 5.945-5.584 6.272zM26.9 26.606c-.085.088-.173.172-.259.257s-.2.2-.3.293-.181.161-.272.245-.208.185-.314.274-.19.154-.285.231-.215.172-.326.255-.2.145-.3.215-.223.161-.336.235-.2.135-.307.2-.231.146-.348.215l-.316.185c-.106.061-.239.134-.359.2s-.215.113-.322.168c-.123.062-.246.121-.37.18-.107.051-.219.1-.33.15l-.382.161c-.111.045-.222.09-.334.133-.131.05-.263.1-.4.142-.112.039-.224.078-.337.115-.134.044-.269.083-.406.123l-.339.1-.131.032a13.335 13.335 0 0 0 3.435-5.577 18.051 18.051 0 0 1 3.682 1.417l-.044.051zm.773-.865a18.673 18.673 0 0 0-4.079-1.623 27.888 27.888 0 0 0 1.085-7.435h6.444a15.015 15.015 0 0 1-3.452 9.058z"
            transform="translate(-783.479 -49.583) translate(800.375 66.48) translate(0 -.022)"
          />
        </g>
      </g>
    </g>
  </SC.Svg>
);

export const SvgSeFormer = ({ ...props }: SvgProps) => (
  <SC.Svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 66 66">
    <defs>
      <filter id="5dnelhzv5a" width="66" height="66" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset />
        <feGaussianBlur result="blur" stdDeviation="2" />
        <feFlood floodOpacity=".878" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g>
      <g filter="url(#5dnelhzv5a)" transform="translate(-1066.868 -49.906) translate(1066.87 49.91)">
        <path fill="#175df9" d="M27 0A27 27 0 1 1 0 27 27 27 0 0 1 27 0z" transform="translate(6 6)" />
      </g>
      <path
        fill="#fff"
        d="M27.774 4.385h-6.335V2.436A2.439 2.439 0 0 0 19 0h-8.768A2.439 2.439 0 0 0 7.8 2.436v1.949H1.462A1.462 1.462 0 0 0 0 5.847v10.846a1.468 1.468 0 0 0 .975 1.376v6.781a1.462 1.462 0 0 0 1.462 1.462H26.8a1.462 1.462 0 0 0 1.462-1.462v-6.78a1.469 1.469 0 0 0 .975-1.376V5.847a1.462 1.462 0 0 0-1.462-1.462zm-19-1.949A1.462 1.462 0 0 1 10.232.975H19a1.462 1.462 0 0 1 1.462 1.462v1.948h-.972V2.436a.487.487 0 0 0-.49-.487h-8.768a.487.487 0 0 0-.487.487v1.949h-.974zm9.745 1.949h-7.8V2.924h7.8zm8.768 20.465a.487.487 0 0 1-.487.487H2.436a.487.487 0 0 1-.487-.487v-6.613l10.72 1.478v1.237a1.462 1.462 0 0 0 1.462 1.462h.975a1.462 1.462 0 0 0 1.462-1.462v-1.237l10.72-1.478zm-11.694-3.9a.487.487 0 0 1-.487.487h-.975a.487.487 0 0 1-.487-.487v-2.921a.487.487 0 0 1 .487-.487h.975a.487.487 0 0 1 .487.487zm12.669-4.259a.487.487 0 0 1-.419.483l-.135.019-11.14 1.536v-.7a1.462 1.462 0 0 0-1.462-1.462h-.975a1.462 1.462 0 0 0-1.462 1.462v.7L1.394 17.176a.487.487 0 0 1-.419-.483V5.847a.487.487 0 0 1 .487-.487h26.312a.487.487 0 0 1 .487.487zm0 0"
        transform="translate(-1066.868 -49.906) translate(1085.25 69.75)"
      />
    </g>
  </SC.Svg>
);

export const SvgAcademy = ({ ...props }: SvgProps) => (
  <SC.Svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 66 66">
    <defs>
      <filter id="Ellipse_4696" x="0" y="0" width="66" height="66" filterUnits="userSpaceOnUse">
        <feOffset />
        <feGaussianBlur stdDeviation="2" result="blur" />
        <feFlood floodOpacity="0.878" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Groupe_294" data-name="Groupe 294" transform="translate(-538 -86)">
      <g transform="matrix(1, 0, 0, 1, 538, 86)" filter="url(#Ellipse_4696)">
        <circle
          id="Ellipse_4696-2"
          data-name="Ellipse 4696"
          cx="27"
          cy="27"
          r="27"
          transform="translate(6 6)"
          fill="white"
        />
      </g>
      <image x="553.5" y="101.5" width="35" height="35" href="/Picto_Happyneuron.svg" />
    </g>
  </SC.Svg>
);

export const SvgEchanger = ({ ...props }: SvgProps) => (
  <SC.Svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 66 66">
    <defs>
      <filter id="iw0hmf3mza" width="66" height="66" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset />
        <feGaussianBlur result="blur" stdDeviation="2" />
        <feFlood floodOpacity=".8" />
        <feComposite in2="blur" operator="in" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g>
      <g filter="url(#iw0hmf3mza)" transform="translate(-1338.229 -49.418) translate(1338.23 49.42)">
        <path fill="#5833ff" d="M27 0A27 27 0 1 1 0 27 27 27 0 0 1 27 0z" transform="translate(6 6)" />
      </g>
      <g>
        <path
          fill="#fff"
          d="M29.586 0H5.516a.5.5 0 0 0-.5.5v4.013H.5a.5.5 0 0 0-.5.5v17.553a.5.5 0 0 0 .5.5h4.515v6.519a.5.5 0 0 0 .309.463.5.5 0 0 0 .192.038.5.5 0 0 0 .355-.147l6.873-6.873h11.827a.5.5 0 0 0 .5-.5v-4.012h4.513a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.498-.5zM24.07 22.064H12.536a.5.5 0 0 0-.355.147l-6.164 6.164v-5.81a.5.5 0 0 0-.5-.5H1V5.516h23.07zm5.015-4.513h-4.012V5.015a.5.5 0 0 0-.5-.5H6.017V1h23.068z"
          transform="translate(-1338.229 -49.418) translate(1356.186 68.25)"
        />
      </g>
    </g>
  </SC.Svg>
);

export const SvgClose = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.299 48.299">
    <g id="Groupe_344" data-name="Groupe 344" transform="translate(-1834.228 -20.611)">
      <path
        id="Tracé_2842"
        data-name="Tracé 2842"
        d="M-12025.736-11733.353l46.178,46.178"
        transform="translate(13861.024 11755.024)"
        fill="none"
        stroke="#262626"
        strokeWidth="3"
      />
      <path
        id="Tracé_2843"
        data-name="Tracé 2843"
        d="M-12025.736-11733.353l46.178,46.178"
        transform="translate(-9851.887 12047.408) rotate(90)"
        fill="none"
        stroke="#262626"
        strokeWidth="3"
      />
    </g>
  </svg>
);

export const SvgCloseBig = () => (
  <svg height="100%" viewBox="0 0 24 24" width="100%">
    <path
      d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      fill="#F5F5F5"
    />
  </svg>
);

export const SvgReduceVideo = () => (
  <svg height="100%" version="1.1" viewBox="0 0 36 36" width="100%">
    <path
      d="M25,17 L17,17 L17,23 L25,23 L25,17 L25,17 Z M29,25 L29,10.98 C29,9.88 28.1,9 27,9 L9,9 C7.9,9 7,9.88 7,10.98 L7,25 C7,26.1 7.9,27 9,27 L27,27 C28.1,27 29,26.1 29,25 L29,25 Z M27,25.02 L9,25.02 L9,10.97 L27,10.97 L27,25.02 L27,25.02 Z"
      fill="#fff"
      id="ytp-id-20"
    />
  </svg>
);

export const SvgDoubleArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 24 24"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#000000"
  >
    <g>
      <rect fill="none" height="24" width="24" />
    </g>
    <g>
      <g>
        <polygon points="6,17.59 7.41,19 12,14.42 16.59,19 18,17.59 12,11.59" />
        <polygon points="6,11 7.41,12.41 12,7.83 16.59,12.41 18,11 12,5" />
      </g>
    </g>
  </svg>
);

export const SvgBack = ({ category }) => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="12"
    height="12"
    viewBox="0 0 284.929 284.929"
    xmlSpace="preserve"
    fill={category === 'training' ? 'var(--color-deep-sky-blue)' : 'var(--color-greenish-cyan)'}
  >
    <g>
      <g>
        <path
          d="M165.304,142.468L277.517,30.267c1.902-1.903,2.847-4.093,2.847-6.567c0-2.475-0.951-4.665-2.847-6.567L263.239,2.857
			C261.337,0.955,259.146,0,256.676,0c-2.478,0-4.665,0.955-6.571,2.857L117.057,135.9c-1.903,1.903-2.853,4.093-2.853,6.567
			c0,2.475,0.95,4.664,2.853,6.567l133.048,133.043c1.903,1.906,4.086,2.851,6.564,2.851c2.478,0,4.66-0.947,6.563-2.851
			l14.277-14.267c1.902-1.903,2.851-4.094,2.851-6.57c0-2.472-0.948-4.661-2.851-6.564L165.304,142.468z"
        />
        <path
          d="M55.668,142.468L167.87,30.267c1.903-1.903,2.851-4.093,2.851-6.567c0-2.475-0.947-4.665-2.851-6.567L153.6,2.857
			C151.697,0.955,149.507,0,147.036,0c-2.478,0-4.668,0.955-6.57,2.857L7.417,135.9c-1.903,1.903-2.853,4.093-2.853,6.567
			c0,2.475,0.95,4.664,2.853,6.567l133.048,133.043c1.902,1.906,4.09,2.851,6.57,2.851c2.471,0,4.661-0.947,6.563-2.851
			l14.271-14.267c1.903-1.903,2.851-4.094,2.851-6.57c0-2.472-0.947-4.661-2.851-6.564L55.668,142.468z"
        />
      </g>
    </g>
  </svg>
);

export const SvgBackAcademy = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 18 18">
    <defs>
      <linearGradient id="linear-gradient" x1="-0.101" x2="0.073" y2="1.07" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#5833ff" />
        <stop offset="0.423" stopColor="#175df9" />
        <stop offset="1" stopColor="#21ffcf" />
      </linearGradient>
    </defs>
    <g id="Groupe_1549" data-name="Groupe 1549" transform="translate(-174.113 -125.75)">
      <path
        id="Tracé_2856"
        data-name="Tracé 2856"
        d="M-17849.887-6574a1,1,0,0,1-.707-.293l-8-8a1,1,0,0,1,0-1.414l8-8a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-7.293,7.293,7.293,7.293a1,1,0,0,1,0,1.414A1,1,0,0,1-17849.887-6574Z"
        transform="translate(18041 6717.75)"
        fill="url(#linear-gradient)"
      />
      <path
        id="Tracé_3155"
        data-name="Tracé 3155"
        d="M-17849.887-6574a1,1,0,0,1-.707-.293l-8-8a1,1,0,0,1,0-1.414l8-8a1,1,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-7.293,7.293,7.293,7.293a1,1,0,0,1,0,1.414A1,1,0,0,1-17849.887-6574Z"
        transform="translate(18033 6717.75)"
        fill="url(#linear-gradient)"
      />
    </g>
  </svg>
);

export const SvgArrowRight = ({ disabled }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="100%"
    viewBox="0 0 24 24"
    width="100%"
    fill={disabled ? '#ffffff63' : 'white'}
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M10.02 6L8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z" />
  </svg>
);

export const SvgLaunchVideo = () => (
  <svg version="1.1" height="100%" width="100%" viewBox="0 0 24 24">
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) ">
        <path
          d="M19,19 L5,19 L5,5 L12,5 L12,3 L5,3 C3.89,3 3,3.9 3,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,12 L19,12 L19,19 Z M14,3 L14,5 L17.59,5 L7.76,14.83 L9.17,16.24 L19,6.41 L19,10 L21,10 L21,3 L14,3 Z"
          fill="#F5F5F5"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);

export const SvgMagicalHat = ({ selected }) => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="35px"
    height="35px"
    viewBox="0 0 29.922 29.922"
    style={{ fill: selected ? '#FFFFFF' : 'var(--color-black)' }}
    xmlSpace="preserve"
  >
    <g>
      <g>
        <g>
          <path
            d="M5.262,8.517c0.086-0.003,0.164-0.053,0.203-0.13c0.039-0.077,0.032-0.169-0.017-0.24L4.327,6.522L4.26,4.549
				C4.257,4.463,4.207,4.385,4.13,4.346C4.053,4.308,3.961,4.314,3.889,4.363L2.264,5.484L0.292,5.551
				c-0.086,0.003-0.164,0.053-0.203,0.13C0.05,5.758,0.057,5.85,0.106,5.921l1.121,1.625l0.067,1.973
				c0.003,0.086,0.053,0.164,0.13,0.203c0.077,0.039,0.169,0.032,0.24-0.017l1.625-1.121L5.262,8.517z"
          />
          <path
            d="M8.954,10.141l-0.471-0.86C8.441,9.206,8.362,9.158,8.276,9.158S8.11,9.206,8.069,9.281l-0.471,0.86l-0.86,0.471
				c-0.076,0.042-0.123,0.121-0.123,0.207c0,0.086,0.047,0.166,0.123,0.207l0.86,0.472l0.471,0.859
				c0.042,0.076,0.121,0.123,0.207,0.123s0.166-0.047,0.207-0.123l0.471-0.859l0.86-0.472c0.076-0.042,0.123-0.121,0.123-0.207
				c0-0.086-0.047-0.166-0.123-0.207L8.954,10.141z"
          />
          <path
            d="M6.255,3.591L7.88,3.595l1.367,0.88c0.072,0.047,0.165,0.05,0.241,0.009c0.076-0.041,0.123-0.12,0.123-0.207l0.004-1.625
				l0.88-1.367c0.047-0.071,0.05-0.164,0.009-0.24c-0.041-0.076-0.12-0.123-0.207-0.123L8.673,0.919l-1.367-0.88
				C7.234-0.01,7.141-0.013,7.065,0.028c-0.076,0.041-0.123,0.12-0.123,0.207L6.938,1.861l-0.88,1.367
				C6.011,3.3,6.008,3.393,6.049,3.469C6.09,3.544,6.168,3.591,6.255,3.591z"
          />
          <path
            d="M12.183,7.035l0.718-0.089l0.653,0.312c0.078,0.038,0.17,0.029,0.24-0.021c0.07-0.051,0.107-0.135,0.096-0.221
				l-0.089-0.718l0.312-0.653c0.038-0.078,0.029-0.17-0.021-0.24C14.041,5.337,13.957,5.3,13.871,5.31l-0.718,0.089L12.5,5.087
				c-0.078-0.038-0.17-0.029-0.24,0.021c-0.07,0.051-0.107,0.135-0.096,0.222l0.089,0.718L11.941,6.7
				c-0.038,0.078-0.029,0.171,0.021,0.24C12.013,7.01,12.097,7.047,12.183,7.035z"
          />
          <path
            d="M29.421,18.38l-0.815-0.814l-9.084-9.084c-0.293-0.293-0.677-0.438-1.062-0.438s-0.769,0.146-1.062,0.438
				c-0.585,0.585-0.586,1.535,0,2.121l8.757,8.757l1.144,1.143c0.586,0.586,1.534,0.586,2.122,0
				c0.146-0.146,0.256-0.314,0.327-0.496c0.073-0.182,0.11-0.373,0.11-0.563C29.86,19.056,29.714,18.672,29.421,18.38z M20.012,11.8
				l-1.905-1.905c-0.195-0.195-0.194-0.512,0-0.707c0.128-0.127,0.277-0.146,0.354-0.146s0.228,0.019,0.354,0.146l1.904,1.905
				L20.012,11.8z"
          />
          <path
            d="M5.027,20.311v8.122c0,0.822,2.854,1.489,6.375,1.489s6.375-0.667,6.375-1.489v-8.122c-1.805,0.403-4.05,0.63-6.375,0.63
				C9.077,20.94,6.831,20.714,5.027,20.311z"
          />
          <path
            d="M11.402,14.809c-5.316,0-9.625,1.148-9.625,2.565c0,0.764,1.261,1.448,3.25,1.918c1.699,0.401,3.927,0.646,6.375,0.646
				c2.449,0,4.676-0.246,6.375-0.646c1.989-0.471,3.25-1.154,3.25-1.918C21.027,15.958,16.718,14.809,11.402,14.809z M11.402,18.963
				c-3.291,0-5.958-0.711-5.958-1.588s2.667-1.589,5.958-1.589s5.958,0.711,5.958,1.589C17.36,18.251,14.692,18.963,11.402,18.963z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const SvgEmail = () => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height="35"
    width="35"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m44.633 247.742v233.723c0 13.682 11.092 24.774 24.774 24.774h339.367l24.675-16.778c.066-.736.099-1.482.099-2.235v-239.484z"
        fill="#ffdc78"
      />
      <path d="m400.517 217.463h-330.323l-33.032 30.279 33.032 30.279 330.322.001 33.032-30.28z" fill="#ffbe45" />
      <path
        d="m189.516 362.022c25.258-23.153 70.959-19.678 96.217 3.475l15.896 3.17s68.64-62.92 98.887-90.646v-195.44c0-4.561-3.697-8.258-8.258-8.258h-305.548l-10.135 199.736 101.43 93.828z"
        fill="#f7f0d7"
      />
      <path
        d="m328.086 74.323c0 41.047 31.383 71.049 72.43 71.049 23.987 0 45.32-8.089 58.909-25.727 9.665-12.544 15.413-28.262 15.413-45.322.001-41.048-33.275-74.323-74.322-74.323-16.986 0-32.641 5.698-45.158 15.287-17.731 13.583-27.272 34.974-27.272 59.036z"
        fill="#ff7e8e"
      />
      <path
        d="m414.029 135.132c-41.047 0-74.323-33.275-74.323-74.323 0-16.943 6.106-33.021 15.652-45.522-17.458 13.596-29.165 35.194-29.165 59.035 0 41.047 33.275 74.323 74.323 74.323 23.842 0 45.313-11.543 58.909-29.001-12.501 9.546-28.453 15.488-45.396 15.488z"
        fill="#fb5f7a"
      />
      <path
        d="m400.516 90.839c-4.565 0-8.258-3.698-8.258-8.258v-41.291c0-4.56 3.694-8.258 8.258-8.258 4.565 0 8.258 3.698 8.258 8.258v41.29c0 4.561-3.693 8.259-8.258 8.259z"
        fill="#fff"
      />
      <path
        d="m400.597 115.613c-4.565 0-8.298-3.698-8.298-8.258s3.653-8.258 8.218-8.258h.081c4.565 0 8.258 3.698 8.258 8.258-.001 4.56-3.695 8.258-8.259 8.258z"
        fill="#fff"
      />
      <g fill="#ffcc5c">
        <path d="m326.194 173.419h-181.678c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h181.677c4.565 0 8.258 3.698 8.258 8.258s-3.693 8.258-8.257 8.258z" />
        <path d="m326.194 214.71h-181.678c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h181.677c4.565 0 8.258 3.698 8.258 8.258s-3.693 8.258-8.257 8.258z" />
        <path d="m326.194 256h-181.678c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h181.677c4.565 0 8.258 3.698 8.258 8.258.001 4.56-3.693 8.258-8.257 8.258z" />
        <path d="m326.194 297.29h-181.678c-4.565 0-8.258-3.698-8.258-8.258s3.694-8.258 8.258-8.258h181.677c4.565 0 8.258 3.698 8.258 8.258s-3.693 8.258-8.257 8.258z" />
        <path d="m301.629 368.668c-2.024 1.855-11.311-3.247-13.29-1.433-2.101 1.926 3.109 10.765 1.069 12.636l126.122 115.613h-317.901c-15.064 0-22.264-18.514-11.16-28.692l94.833-86.922-1.56-10.246-10.661-.956-87.727 80.416c-10.593 9.711-27.676 2.196-27.676-12.175v-174.02l-16.516-15.147v239.484c0 13.682 11.092 24.774 24.774 24.774h346.839c10.771 0 19.92-6.916 23.333-16.516.695-1.942 1.154-3.887 1.342-6.023z" />
      </g>
      <path
        d="m301.629 368.668-9.216-8.448c-10.034-9.198-21.908-16.428-35.058-19.944-23.049-6.164-46.563-2.346-65.647 9.554-6.478 4.039-14.754 3.649-20.381-1.509l-76.584-70.201c-5.119-4.693-8.034-11.318-8.034-18.262v-185.535h-8.258c-4.561 0-8.258 3.697-8.258 8.258v195.441l111.109 101.85 9.411-8.627c12.629-11.577 28.636-17.365 44.642-17.365s32.013 5.788 44.641 17.365l9.411 8.627z"
        fill="#fae6c2"
      />
    </g>
  </svg>
);

export const SvgStar = ({ hovered, ...props }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.481 19.481"
    enableBackground="new 0 0 19.481 19.481"
    height="100%"
    width="100%"
    {...props}
  >
    <g>
      <path
        stroke="var(--color-deep-sky-blue)"
        strokeWidth="1"
        fill={hovered ? 'var(--color-deep-sky-blue)' : 'white'}
        d="m10.201,.758l2.478,5.865 6.344,.545c0.44,0.038 0.619,0.587 0.285,0.876l-4.812,4.169 1.442,6.202c0.1,0.431-0.367,0.77-0.745,0.541l-5.452-3.288-5.452,3.288c-0.379,0.228-0.845-0.111-0.745-0.541l1.442-6.202-4.813-4.17c-0.334-0.289-0.156-0.838 0.285-0.876l6.344-.545 2.478-5.864c0.172-0.408 0.749-0.408 0.921,0z"
      />
    </g>
  </svg>
);

export const SvgHalfStar = ({ ...props }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19.481 19.481"
    enableBackground="new 0 0 19.481 19.481"
    height="100%"
    width="100%"
    {...props}
  >
    <defs>
      <linearGradient id="MyGradient" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="var(--color-deep-sky-blue)" />
        <stop offset="0%" stopColor="var(--color-deep-sky-blue)" />
        <stop offset="50%" stopColor="var(--color-deep-sky-blue)" />
        <stop offset="50%" stopColor="white" />
        <stop offset="100%" stopColor="white" />
      </linearGradient>
    </defs>
    <g>
      <path
        stroke="var(--color-deep-sky-blue)"
        strokeWidth="1"
        fill="url(#MyGradient)"
        d="m10.201,.758l2.478,5.865 6.344,.545c0.44,0.038 0.619,0.587 0.285,0.876l-4.812,4.169 1.442,6.202c0.1,0.431-0.367,0.77-0.745,0.541l-5.452-3.288-5.452,3.288c-0.379,0.228-0.845-0.111-0.745-0.541l1.442-6.202-4.813-4.17c-0.334-0.289-0.156-0.838 0.285-0.876l6.344-.545 2.478-5.864c0.172-0.408 0.749-0.408 0.921,0z"
      />
    </g>
  </svg>
);

export const SvgGoBack = () => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    height="18px"
    width="18px"
    x="0px"
    y="0px"
    viewBox="0 0 490.667 490.667"
    xmlSpace="preserve"
  >
    <path
      fill="#535353"
      d="M239.077,245.333L466.213,18.219c4.171-4.16,4.179-10.914,0.019-15.085
	c-2.006-2.011-4.731-3.139-7.571-3.134h-192c-2.831-0.005-5.548,1.115-7.552,3.115L24.443,237.781
	c-4.164,4.165-4.164,10.917,0,15.083l234.667,234.667c2.001,2.007,4.718,3.135,7.552,3.136h192
	c5.891,0.011,10.675-4.757,10.686-10.648c0.005-2.84-1.123-5.565-3.134-7.571L239.077,245.333z"
    />
  </svg>
);

export const SvgHeart = ({ selected, home }) => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    height="100%"
    width="100%"
    viewBox="0 0 412.735 412.735"
    xmlSpace="preserve"
    fill={selected && home === 'formations' ? 'white' : '#575757'}
  >
    <g>
      <g>
        <path
          d="M295.706,35.522C295.706,35.522,295.706,35.522,295.706,35.522c-34.43-0.184-67.161,14.937-89.339,41.273
			c-22.039-26.516-54.861-41.68-89.339-41.273C52.395,35.522,0,87.917,0,152.55C0,263.31,193.306,371.456,201.143,375.636
			c3.162,2.113,7.286,2.113,10.449,0c7.837-4.18,201.143-110.759,201.143-223.086C412.735,87.917,360.339,35.522,295.706,35.522z
			 M206.367,354.738C176.065,336.975,20.898,242.412,20.898,152.55c0-53.091,43.039-96.131,96.131-96.131
			c32.512-0.427,62.938,15.972,80.457,43.363c3.557,4.905,10.418,5.998,15.323,2.44c0.937-0.68,1.761-1.503,2.44-2.44
			c29.055-44.435,88.631-56.903,133.066-27.848c27.202,17.787,43.575,48.114,43.521,80.615
			C391.837,243.456,236.669,337.497,206.367,354.738z"
        />
      </g>
    </g>
  </svg>
);

export const SvgOfferteCard = ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.72 77.006">
    <g id="Groupe_1141" data-name="Groupe 1141" transform="translate(11783.904 8836)">
      <path
        id="Tracé_2848"
        data-name="Tracé 2848"
        d="M-5.9,63.622,35.14,22H66.815L-5.9,99.006Z"
        transform="translate(-11778 -8858)"
        fill={color || '#f917d6'}
      />
      <path
        id="OFFERTE_"
        data-name="OFFERTE !"
        d="M10.914,14.168A3.24,3.24,0,0,1,9.549,13.9a2.667,2.667,0,0,1-.994-.777A3.554,3.554,0,0,1,7.946,11.9a5.594,5.594,0,0,1-.21-1.582,6.658,6.658,0,0,1,.329-2.065,6.413,6.413,0,0,1,.917-1.82,4.758,4.758,0,0,1,1.407-1.3,3.464,3.464,0,0,1,1.813-.49,3.24,3.24,0,0,1,1.365.273,2.667,2.667,0,0,1,.994.777,3.561,3.561,0,0,1,.609,1.211,5.521,5.521,0,0,1,.21,1.575,6.724,6.724,0,0,1-.329,2.072,6.393,6.393,0,0,1-.917,1.827,4.726,4.726,0,0,1-1.414,1.3A3.476,3.476,0,0,1,10.914,14.168Zm.056-.938a2.3,2.3,0,0,0,1.351-.427,3.919,3.919,0,0,0,1.043-1.1,5.6,5.6,0,0,0,.672-1.5,5.847,5.847,0,0,0,.238-1.624A4.03,4.03,0,0,0,13.756,6.4a1.769,1.769,0,0,0-1.61-.819,2.327,2.327,0,0,0-1.351.42A3.829,3.829,0,0,0,9.752,7.1,5.6,5.6,0,0,0,9.08,8.6a5.894,5.894,0,0,0-.238,1.638,5.521,5.521,0,0,0,.126,1.225,2.847,2.847,0,0,0,.385.945,1.809,1.809,0,0,0,.665.609A1.991,1.991,0,0,0,10.97,13.23Zm6.65.77,1.834-9.184h5.068l-.182.91H20.35l-.63,3.192h3.374l-.182.924h-3.36L18.712,14Zm7.994,0,1.834-9.184h5.068l-.182.91h-3.99l-.63,3.192h3.374l-.182.924h-3.36L26.706,14Zm7.994,0,1.834-9.184H40.51l-.182.91h-3.99L35.75,8.708h3.374l-.2.924H35.582l-.714,3.444h4.116l-.2.924Zm8.414,0,1.834-9.184h2.52a5.3,5.3,0,0,1,1.169.119,2.6,2.6,0,0,1,.9.378,1.793,1.793,0,0,1,.588.665,2.111,2.111,0,0,1,.21.98,3.122,3.122,0,0,1-.2,1.148,2.771,2.771,0,0,1-.567.9,3.142,3.142,0,0,1-.854.637,3.966,3.966,0,0,1-1.078.364L48.154,14H46.992L45.48,10.108h-1.6L43.114,14Zm2.044-4.774h1.386a3.107,3.107,0,0,0,2.016-.574,1.9,1.9,0,0,0,.7-1.554,1.181,1.181,0,0,0-.525-1.085,2.912,2.912,0,0,0-1.533-.329H44.766ZM52.494,14l1.638-8.246h-2.66l.182-.938H58.08l-.182.938H55.224L53.586,14Zm6.678,0,1.834-9.184h5.068l-.182.91H61.9l-.588,2.982h3.374l-.2.924H61.146l-.714,3.444h4.116l-.2.924Zm13.412-2.744.938-5.362.21-1.288H74.81l-.266,1.288-1.2,5.362Zm-.154,2.912a.636.636,0,0,1-.49-.2.711.711,0,0,1-.182-.5,1.007,1.007,0,0,1,.266-.672.85.85,0,0,1,.672-.308.579.579,0,0,1,.483.2.8.8,0,0,1,.161.511,1.012,1.012,0,0,1-.252.665A.817.817,0,0,1,72.43,14.168Z"
        transform="matrix(0.695, -0.719, 0.719, 0.695, -11789.904, -8783.523)"
        fill="#fff"
        stroke="#fff"
        strokeWidth="1"
      />
    </g>
  </svg>
);

export const SvgTrash = () => (
  <SC.SvgTrash xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 62">
    <defs>
      <filter id="Ellipse_4796" x="0" y="0" filterUnits="userSpaceOnUse">
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feFlood floodOpacity="0.161" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Btn_Supprimer" data-name="Btn Supprimer" transform="translate(-535 -108)">
      <g transform="matrix(1, 0, 0, 1, 535, 108)" filter="url(#Ellipse_4796)">
        <circle id="Ellipse_4796-2" data-name="Ellipse 4796" cx="22" cy="22" r="22" transform="translate(9 6)" fill="#fff" />
      </g>
      <g id="Icon_poubelle" data-name="Icon poubelle" transform="translate(551.197 121.552)">
        <SC.PathTrash
          id="Tracé_3124"
          data-name="Tracé 3124"
          d="M4.5,9H25.107"
          transform="translate(0 -1.421)"
          fill="none"
          stroke="#707070"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <SC.PathTrash
          id="Tracé_3125"
          data-name="Tracé 3125"
          d="M23.528,7.579V23.607a2.29,2.29,0,0,1-2.29,2.29H9.79a2.29,2.29,0,0,1-2.29-2.29V7.579m3.434,0V5.29A2.29,2.29,0,0,1,13.224,3H17.8a2.29,2.29,0,0,1,2.29,2.29v2.29"
          transform="translate(-0.71)"
          fill="none"
          stroke="#707070"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <SC.PathTrash
          id="Tracé_3126"
          data-name="Tracé 3126"
          d="M15,16.5v6.869"
          transform="translate(-2.486 -3.197)"
          fill="none"
          stroke="#707070"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <SC.PathTrash
          id="Tracé_3127"
          data-name="Tracé 3127"
          d="M21,16.5v6.869"
          transform="translate(-3.907 -3.197)"
          fill="none"
          stroke="#707070"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </g>
  </SC.SvgTrash>
);

export const SvgBecomeCoach = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 101 101">
    <defs>
      <clipPath id="clip-path">
        <circle
          id="Ellipse_4745"
          data-name="Ellipse 4745"
          cx="50.5"
          cy="50.5"
          r="50.5"
          transform="translate(238 4760.5)"
          fill="#fff"
        />
      </clipPath>
    </defs>
    <g id="Groupe_793" data-name="Groupe 793" transform="translate(-238 -4760.5)">
      <circle
        id="Ellipse_4744"
        data-name="Ellipse 4744"
        cx="50.5"
        cy="50.5"
        r="50.5"
        transform="translate(238 4760.5)"
        fill="#5833FF"
      />
      <g id="Groupe_de_masques_18" data-name="Groupe de masques 18" clipPath="url(#clip-path)">
        <path
          id="Icon_awesome-user-alt"
          data-name="Icon awesome-user-alt"
          d="M38.93,43.8a21.9,21.9,0,1,0-21.9-21.9A21.9,21.9,0,0,0,38.93,43.8Zm19.465,4.866H50.016a26.471,26.471,0,0,1-22.172,0H19.465A19.463,19.463,0,0,0,0,68.127V70.56a7.3,7.3,0,0,0,7.3,7.3H70.56a7.3,7.3,0,0,0,7.3-7.3V68.127A19.463,19.463,0,0,0,58.395,48.662Z"
          transform="translate(249.57 4783.641)"
          fill="#fff"
          opacity="0.84"
        />
      </g>
    </g>
  </svg>
);

export const SvgEchangerHolder = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 536.69 366.53">
    <g id="Groupe_8699" data-name="Groupe 8699" transform="translate(-412 -227.472)">
      <path
        id="Tracé_9978"
        data-name="Tracé 9978"
        d="M-12981.687,19172.258c-75.244,58.416-89.3,162.4,66.689,261.375s344.475-32.988,318.477-206.2S-12906.441,19113.844-12981.687,19172.258Z"
        transform="translate(-12134.805 19706.984) rotate(180)"
        fill="#927aff"
      />
      <g id="Groupe_8698" data-name="Groupe 8698" transform="translate(412 151.07)">
        <path
          id="Tracé_9917"
          data-name="Tracé 9917"
          d="M348.952,491.474c-25.093-24.7-35.69-50.472-29.842-72.562,7.505-28.349,40.846-47.95,91.474-53.776l.187,1.626c-49.923,5.745-82.755,24.906-90.079,52.569-5.691,21.5,4.753,46.706,29.408,70.978Z"
          transform="translate(-233.735 -207.364)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9918"
          data-name="Tracé 9918"
          d="M620.163,648.245c-31.317,0-65.348-4.654-99.151-13.6-41.8-11.067-80.13-27.77-110.839-48.306l.909-1.36c30.562,20.436,68.72,37.064,110.349,48.084,37.619,9.96,75.521,14.575,109.593,13.357l.059,1.635Q625.685,648.245,620.163,648.245Z"
          transform="translate(-262.845 -276.451)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9919"
          data-name="Tracé 9919"
          d="M765.49,574.292l-.524-1.55c28.009-9.47,45.527-24.725,50.661-44.117,6.526-24.652-7.652-53.259-39.923-80.552C743.269,420.641,696.5,397.88,644,383.983l.419-1.582c52.725,13.958,99.726,36.837,132.342,64.423,32.781,27.723,47.146,56.923,40.449,82.22C811.929,548.992,794.044,564.638,765.49,574.292Z"
          transform="translate(-336.327 -212.79)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9920"
          data-name="Tracé 9920"
          d="M384.931,632.13c-61.536-27.292-108.954-62.7-133.519-99.7l1.363-.905c24.395,36.746,71.564,71.944,132.819,99.111Z"
          transform="translate(-212.954 -259.653)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9921"
          data-name="Tracé 9921"
          d="M752.75,738.47q-9.521,0-19.367-.425l.07-1.635c48.985,2.121,92.2-3.741,125-16.956l.612,1.518C830.457,732.5,794,738.47,752.75,738.47Z"
          transform="translate(-364.417 -318.712)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9922"
          data-name="Tracé 9922"
          d="M616.8,353.959c-10.171-3.311-20.632-6.395-31.094-9.164-60.2-15.938-119.383-21.6-171.144-16.361L414.4,326.8c51.955-5.252,111.337.42,171.728,16.408,10.491,2.778,20.982,5.87,31.182,9.191Z"
          transform="translate(-264.174 -194.721)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9923"
          data-name="Tracé 9923"
          d="M292.869,495.054c-25.092-24.7-35.69-50.472-29.842-72.562,7.505-28.349,40.846-47.95,91.474-53.776l.187,1.626c-49.923,5.745-82.755,24.906-90.079,52.569-5.691,21.5,4.753,46.706,29.408,70.978Z"
          transform="translate(-216.11 -208.49)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9924"
          data-name="Tracé 9924"
          d="M564.081,651.824c-31.317,0-65.348-4.654-99.151-13.6-41.8-11.066-80.13-27.77-110.839-48.306l.909-1.36c30.562,20.436,68.72,37.064,110.349,48.084,37.619,9.96,75.521,14.575,109.593,13.357l.059,1.635Q569.6,651.825,564.081,651.824Z"
          transform="translate(-245.221 -277.576)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9925"
          data-name="Tracé 9925"
          d="M709.407,577.872l-.524-1.55c28.009-9.47,45.527-24.725,50.661-44.117,6.526-24.652-7.652-53.259-39.923-80.552-32.436-27.431-79.209-50.193-131.7-64.09l.419-1.582c52.725,13.959,99.726,36.837,132.342,64.422,32.781,27.724,47.146,56.923,40.449,82.22C755.846,552.572,737.961,568.218,709.407,577.872Z"
          transform="translate(-318.703 -213.915)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9926"
          data-name="Tracé 9926"
          d="M328.848,635.71c-61.536-27.292-108.954-62.7-133.519-99.7l1.363-.905c24.395,36.746,71.564,71.944,132.819,99.112Z"
          transform="translate(-195.329 -260.778)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9927"
          data-name="Tracé 9927"
          d="M696.667,742.051q-9.521,0-19.367-.425l.07-1.635c48.985,2.121,92.2-3.741,125-16.956l.612,1.518C774.374,736.079,737.915,742.051,696.667,742.051Z"
          transform="translate(-346.792 -319.837)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9928"
          data-name="Tracé 9928"
          d="M560.72,357.539c-10.171-3.311-20.632-6.395-31.094-9.164-60.2-15.938-119.383-21.6-171.144-16.361l-.165-1.629c51.955-5.252,111.337.42,171.728,16.408,10.491,2.778,20.982,5.87,31.182,9.191Z"
          transform="translate(-246.549 -195.846)"
          fill="#f0f0f0"
        />
        <path
          id="Tracé_9929"
          data-name="Tracé 9929"
          d="M226.451,480.866c11.76-13.186,30.52-21.222,47.521-16.411a81.4,81.4,0,0,0-31.766,45.984c-1.837,7.179-3.132,15.354-9.1,19.744-3.715,2.731-8.637,3.384-13.205,2.762s-8.888-2.4-13.15-4.159l-1.147.1C208.9,511.526,214.691,494.051,226.451,480.866Z"
          transform="translate(-198.557 -238.134)"
          fill="#f2f2f2"
        />
        <path
          id="Tracé_9930"
          data-name="Tracé 9930"
          d="M273.968,465.274a69.579,69.579,0,0,0-36.49,22.385,29.963,29.963,0,0,0-5.052,7.912,17.185,17.185,0,0,0-1.014,8.987c.382,2.836,1.1,5.694.786,8.574a10.522,10.522,0,0,1-4.46,7.359c-2.985,2.18-6.576,3.157-10.121,3.991-3.936.926-8.038,1.825-11.246,4.44-.389.317-.858-.3-.47-.621,5.582-4.55,13.339-3.966,19.514-7.271,2.882-1.542,5.316-3.962,5.908-7.283.518-2.9-.221-5.851-.633-8.719a18.337,18.337,0,0,1,.664-8.825,27.7,27.7,0,0,1,4.73-8.077A67.5,67.5,0,0,1,251.8,474.051a70.812,70.812,0,0,1,22.075-9.55c.486-.118.575.657.092.773Z"
          transform="translate(-198.606 -238.587)"
          fill="#fff"
        />
        <path
          id="Tracé_9931"
          data-name="Tracé 9931"
          d="M254.96,486.538a10.439,10.439,0,0,1-.322-13.514c.317-.388.935.085.618.474a9.666,9.666,0,0,0,.325,12.57c.335.372-.288.84-.621.47Z"
          transform="translate(-213.237 -241.224)"
          fill="#fff"
        />
        <path
          id="Tracé_9932"
          data-name="Tracé 9932"
          d="M242.412,518.794a20.121,20.121,0,0,0,13.979-4.426c.39-.316.859.306.47.621a20.929,20.929,0,0,1-14.556,4.576C241.8,519.53,241.914,518.759,242.412,518.794Z"
          transform="translate(-209.989 -254.235)"
          fill="#fff"
        />
        <path
          id="Tracé_9933"
          data-name="Tracé 9933"
          d="M282.7,473.4a5.909,5.909,0,0,0,4.769,2.949c.5.028.391.8-.107.771a6.622,6.622,0,0,1-5.283-3.251.4.4,0,0,1,.076-.545A.391.391,0,0,1,282.7,473.4Z"
          transform="translate(-222.567 -241.34)"
          fill="#fff"
        />
        <path
          id="Tracé_9934"
          data-name="Tracé 9934"
          d="M297.7,537.328c-.313-.009-.627-.018-.944-.021a77.807,77.807,0,0,0-12.6.735c-.323.04-.651.086-.972.135a82.039,82.039,0,0,0-28.522,9.938,79.669,79.669,0,0,0-10.009,6.809c-4.362,3.481-8.815,7.6-13.921,9.385a13.668,13.668,0,0,1-1.623.476l-23.7-16.374c-.035-.064-.074-.123-.11-.188l-.976-.611c.154-.141.316-.285.47-.426.089-.082.183-.161.272-.243.061-.054.122-.107.174-.159.02-.018.041-.036.057-.048.052-.052.106-.095.154-.141q1.36-1.205,2.741-2.4c0-.005,0-.005.013-.007A117.144,117.144,0,0,1,231.027,528.5c.246-.125.5-.256.754-.374a76.02,76.02,0,0,1,11.506-4.64,67.232,67.232,0,0,1,6.592-1.668,55.885,55.885,0,0,1,17.461-.669c11.6,1.385,22.629,6.464,29.819,15.482C297.343,536.864,297.522,537.091,297.7,537.328Z"
          transform="translate(-198.156 -256.27)"
          fill="#f2f2f2"
        />
        <path
          id="Tracé_9935"
          data-name="Tracé 9935"
          d="M297.647,542.32a69.579,69.579,0,0,0-42.613-4.1,29.965,29.965,0,0,0-8.8,3.276,17.185,17.185,0,0,0-6.221,6.565c-1.4,2.495-2.549,5.209-4.534,7.319a10.523,10.523,0,0,1-7.992,3.191c-3.7-.057-7.151-1.438-10.483-2.907-3.7-1.63-7.517-3.383-11.653-3.226-.5.019-.5-.76,0-.779,7.2-.273,13.038,4.864,19.959,5.943,3.229.5,6.63.037,9.1-2.258,2.161-2.007,3.346-4.8,4.744-7.343A18.337,18.337,0,0,1,245,541.359a27.7,27.7,0,0,1,8.64-3.6,67.5,67.5,0,0,1,21.023-1.775,70.812,70.812,0,0,1,23.375,5.665c.459.2.063.87-.392.673Z"
          transform="translate(-198.361 -260.998)"
          fill="#fff"
        />
        <path
          id="Tracé_9936"
          data-name="Tracé 9936"
          d="M284.577,532.421a10.439,10.439,0,0,1,7.879-10.983c.487-.12.7.631.208.751a9.666,9.666,0,0,0-7.309,10.232c.043.5-.736.5-.779,0Z"
          transform="translate(-223.365 -256.479)"
          fill="#fff"
        />
        <path
          id="Tracé_9937"
          data-name="Tracé 9937"
          d="M256.557,551.656a20.121,20.121,0,0,0,13.827,4.882c.5-.017.5.761,0,.779a20.928,20.928,0,0,1-14.377-5.11c-.379-.329.173-.879.55-.551Z"
          transform="translate(-214.357 -265.948)"
          fill="#fff"
        />
        <path
          id="Tracé_9938"
          data-name="Tracé 9938"
          d="M317.283,538.013a5.909,5.909,0,0,0,2.032,5.226c.383.324-.17.873-.55.551a6.622,6.622,0,0,1-2.261-5.776.4.4,0,0,1,.389-.39.391.391,0,0,1,.39.389Z"
          transform="translate(-233.396 -261.57)"
          fill="#fff"
        />
        <path
          id="Tracé_9939"
          data-name="Tracé 9939"
          d="M890.011,632.252c-6.645-16.371-21.612-30.245-39.24-31.428a81.4,81.4,0,0,1,14.463,53.986c-.683,7.378-2.211,15.514,1.937,21.654,2.581,3.821,7,6.09,11.509,7.039s9.177.728,13.783.5l1.047.479C896.238,667.028,896.655,648.624,890.011,632.252Z"
          transform="translate(-401.307 -281.432)"
          fill="#f2f2f2"
        />
        <path
          id="Tracé_9940"
          data-name="Tracé 9940"
          d="M850.576,601.006a69.579,69.579,0,0,1,26.844,33.347,29.965,29.965,0,0,1,2.1,9.15,17.185,17.185,0,0,1-2.065,8.806c-1.313,2.543-2.95,4.992-3.622,7.81a10.522,10.522,0,0,0,1.727,8.43c2.079,3.057,5.132,5.184,8.191,7.16,3.4,2.195,6.957,4.42,9.1,7.962.26.429.91,0,.651-.427-3.727-6.162-11.23-8.219-15.935-13.407-2.2-2.421-3.675-5.518-3.116-8.845.489-2.909,2.175-5.436,3.527-8a18.338,18.338,0,0,0,2.34-8.535,27.7,27.7,0,0,0-1.74-9.2A67.506,67.506,0,0,0,868.5,616.722a70.815,70.815,0,0,0-17.581-16.414c-.418-.274-.762.425-.347.7Z"
          transform="translate(-401.187 -281.25)"
          fill="#fff"
        />
        <path
          id="Tracé_9941"
          data-name="Tracé 9941"
          d="M887.453,637.523A10.439,10.439,0,0,0,892.3,624.9c-.168-.472-.909-.234-.741.239a9.666,9.666,0,0,1-4.531,11.729c-.441.238-.011.888.427.651Z"
          transform="translate(-412.642 -288.918)"
          fill="#fff"
        />
        <path
          id="Tracé_9942"
          data-name="Tracé 9942"
          d="M885.4,670.27A20.12,20.12,0,0,1,873.72,661.4c-.261-.428-.912,0-.651.427a20.928,20.928,0,0,0,12.171,9.2c.483.136.639-.628.158-.763Z"
          transform="translate(-408.295 -300.413)"
          fill="#fff"
        />
        <path
          id="Tracé_9943"
          data-name="Tracé 9943"
          d="M866.23,616.173a5.909,5.909,0,0,1-5.482,1.175c-.481-.142-.637.622-.158.762a6.621,6.621,0,0,0,6.068-1.286.4.4,0,0,0,.112-.539.391.391,0,0,0-.539-.112Z"
          transform="translate(-404.301 -286.235)"
          fill="#fff"
        />
        <path
          id="Tracé_9944"
          data-name="Tracé 9944"
          d="M790.8,661.263c.3.1.6.194.9.3a77.812,77.812,0,0,1,11.622,4.928c.291.147.584.3.87.454a82.04,82.04,0,0,1,23.523,18.946,79.657,79.657,0,0,1,7.138,9.776c2.938,4.744,5.747,10.122,9.957,13.518a13.649,13.649,0,0,0,1.369.994L874,702.721c.055-.049.111-.091.167-.14l1.125-.247c-.1-.185-.2-.374-.3-.559-.056-.107-.118-.213-.174-.321-.039-.071-.079-.142-.11-.209-.013-.024-.026-.047-.038-.065-.031-.066-.068-.125-.1-.185q-.876-1.592-1.777-3.178c0-.006,0-.006-.01-.011A117.141,117.141,0,0,0,856.56,675.36c-.19-.2-.381-.408-.584-.606a76.024,76.024,0,0,0-9.277-8.237,67.215,67.215,0,0,0-5.648-3.787,55.89,55.89,0,0,0-16.22-6.5c-11.391-2.595-23.486-1.517-33.288,4.559C791.292,660.947,791.047,661.1,790.8,661.263Z"
          transform="translate(-382.46 -298.429)"
          fill="#f2f2f2"
        />
        <path
          id="Tracé_9945"
          data-name="Tracé 9945"
          d="M790.821,664.244a69.579,69.579,0,0,1,41.511,10.464,29.959,29.959,0,0,1,7.185,6.042,17.186,17.186,0,0,1,3.653,8.274c.483,2.821.65,5.763,1.81,8.417a10.523,10.523,0,0,0,6.455,5.691c3.5,1.189,7.219,1.049,10.851.786,4.032-.292,8.216-.659,12.059.878.466.186.728-.547.263-.733-6.686-2.676-13.915.2-20.8-1.111-3.211-.611-6.257-2.194-7.813-5.186-1.361-2.617-1.536-5.65-2-8.51a18.336,18.336,0,0,0-3.27-8.223,27.7,27.7,0,0,0-6.926-6.3A67.505,67.505,0,0,0,814.6,666a70.812,70.812,0,0,0-23.92-2.521c-.5.033-.352.8.143.766Z"
          transform="translate(-382.325 -301.073)"
          fill="#fff"
        />
        <path
          id="Tracé_9946"
          data-name="Tracé 9946"
          d="M843.965,669.951a10.439,10.439,0,0,0-3.729-12.993c-.418-.276-.867.361-.448.637a9.666,9.666,0,0,1,3.444,12.093C843.023,670.143,843.757,670.4,843.965,669.951Z"
          transform="translate(-397.803 -299.051)"
          fill="#fff"
        />
        <path
          id="Tracé_9947"
          data-name="Tracé 9947"
          d="M860.331,698.632a20.12,20.12,0,0,1-14.663-.049c-.466-.185-.728.549-.263.733a20.929,20.929,0,0,0,15.258.02c.468-.183.132-.886-.333-.7Z"
          transform="translate(-399.544 -312.144)"
          fill="#fff"
        />
        <path
          id="Tracé_9948"
          data-name="Tracé 9948"
          d="M812.781,665.394a5.909,5.909,0,0,1-3.67,4.239c-.47.177-.134.88.333.7a6.621,6.621,0,0,0,4.07-4.68.4.4,0,0,0-.235-.5.391.391,0,0,0-.5.235Z"
          transform="translate(-388.144 -301.642)"
          fill="#fff"
        />
        <circle
          id="Ellipse_4889"
          data-name="Ellipse 4889"
          cx="6.546"
          cy="6.546"
          r="6.546"
          transform="translate(353.25 393.475)"
          fill="#fd6584"
        />
        <circle
          id="Ellipse_4890"
          data-name="Ellipse 4890"
          cx="6.546"
          cy="6.546"
          r="6.546"
          transform="translate(376.438 281.98)"
          fill="#e6e6e6"
        />
        <circle
          id="Ellipse_4891"
          data-name="Ellipse 4891"
          cx="6.546"
          cy="6.546"
          r="6.546"
          transform="translate(254.63 100.404)"
          fill="#e6e6e6"
        />
        <path
          id="Tracé_9949"
          data-name="Tracé 9949"
          d="M376.155,623.353c0,1.666.055,3.333.171,4.985.123,1.975.336,3.936.624,5.884a73.545,73.545,0,0,0,5.5,19.016l.411.905.206.453c.069.151.144.3.213.446.1.2.185.391.281.583.117.24.233.48.357.72.014.027.027.062.048.1.1.206.2.4.309.61a1.193,1.193,0,0,0,.069.13c.117.233.24.473.363.706s.267.5.4.747c.329.61.672,1.214,1.022,1.817.1.178.206.357.315.535s.192.329.295.494c.069.11.137.226.206.336.11.185.219.364.336.549.254.4.514.809.768,1.214h.007c.117.185.24.37.363.549v.007c.363.549.741,1.1,1.118,1.639l0,0a.007.007,0,0,1,0,0c.3.439.617.864.926,1.289v.007c.206.267.4.542.61.809.165.219.336.446.507.665.034.048.075.089.11.137v.007c.048.062.1.116.144.178q1.09,1.4,2.249,2.736l.123.144c.041.048.089.1.13.151.069.075.13.151.2.226s.13.151.2.226a74.481,74.481,0,0,0,13.6,11.994c.665.459,1.344.905,2.023,1.337.171.11.343.219.514.322.048.034.1.069.151.1.1.055.185.11.281.171s.178.11.274.165c.363.226.734.446,1.1.665.089.055.185.11.281.165s.185.1.281.158c0,.007,0,.007.007.007h.007v.007h.007q.689.4,1.4.782c.254.137.514.281.775.411.59.322,1.186.631,1.783.926.213.1.432.206.645.315.178.082.357.171.535.254.055.027.1.048.151.075.151.069.295.137.446.206s.329.151.487.226c.185.082.363.164.549.24.686.309,1.378.6,2.071.885a72.633,72.633,0,0,0,7.6,2.633c.117.034.24.069.363.1q1.656.463,3.333.843,2.932.679,5.918,1.111h.014l.713.1c.021,0,.041.007.069.007,0,.007,0,.007.007,0l.789.1a.17.17,0,0,0,.055.007c.247.034.5.062.747.089l.8.082.617.062a.134.134,0,0,0,.055.007c.185.014.37.034.555.048h.027l.48.041c1.913.151,3.833.219,5.781.219,2.105,0,4.2-.082,6.261-.261h.021l1.323-.123c.117-.014.226-.021.343-.034.021,0,.048-.007.069-.007s.069-.007.11-.014a.17.17,0,0,0,.055-.007c.151-.014.3-.034.46-.048l.514-.062c.171-.021.343-.048.514-.069.041-.007.075-.007.117-.014.123-.014.247-.034.37-.055l.178-.021c.123-.021.24-.034.363-.055h.007a72.5,72.5,0,0,0,11.109-2.5c.192-.062.384-.117.576-.178.007,0,.014-.007.021-.007.055-.021.117-.034.171-.055.514-.165,1.022-.336,1.529-.514.7-.233,1.392-.487,2.085-.747.185-.075.37-.144.555-.219.377-.144.747-.295,1.118-.446.631-.254,1.262-.521,1.886-.8.583-.261,1.159-.521,1.735-.8.014-.007.034-.007.048-.021.13-.062.261-.123.384-.185h.007a73.5,73.5,0,0,0,9.114-5.2q1.4-.936,2.757-1.934c.727-.542,1.44-1.09,2.153-1.653a74.244,74.244,0,0,0,9.731-9.3V671.9c.213-.233.411-.473.617-.713.034-.034.062-.069.089-.1.13-.158.254-.309.384-.459v-.007c.171-.2.343-.4.507-.61l.11-.13v-.007c.137-.165.267-.329.4-.5.069-.082.13-.165.2-.247v-.007c.4-.507.8-1.015,1.186-1.536.1-.137.206-.281.315-.425.494-.665.974-1.344,1.44-2.023v-.007c.178-.254.35-.514.528-.768l.514-.782c.172-.274.35-.542.521-.816l.021-.041c.171-.261.343-.535.507-.8.13-.219.261-.432.391-.645.082-.144.171-.288.254-.439a1.647,1.647,0,0,0,.089-.144l.576-1.008c.226-.391.446-.789.665-1.186.082-.165.171-.329.261-.494.034-.055.062-.11.089-.165.1-.192.206-.391.3-.59s.206-.391.309-.59.2-.391.295-.59c.075-.151.144-.3.219-.453a.149.149,0,0,1,.021-.034c.034-.075.069-.144.1-.213a.146.146,0,0,0,.021-.034c.075-.151.144-.309.22-.459.1-.2.185-.4.281-.6.062-.137.13-.281.192-.425.089-.2.185-.4.267-.6s.185-.411.274-.624a1.581,1.581,0,0,0,.068-.158c.048-.1.082-.192.123-.288.11-.254.219-.514.322-.768.123-.288.24-.583.35-.871.11-.267.213-.542.315-.816l.041-.1a74.293,74.293,0,0,0,3.621-12.981v-.007a75.04,75.04,0,0,0,.981-7.639c.007-.144.021-.281.027-.418.123-1.735.178-3.477.178-5.225,0-.775-.014-1.543-.034-2.311a73.527,73.527,0,0,0-16.307-44.025c-.219-.274-.439-.548-.665-.823s-.459-.542-.686-.809a73.888,73.888,0,0,0-118.661,8.524c-.336.535-.672,1.077-.994,1.618s-.645,1.1-.96,1.653a73.564,73.564,0,0,0-9.45,36.173Z"
          transform="translate(-252.155 -265.295)"
          fill="#f2f2f2"
        />
        <path
          id="Tracé_9950"
          data-name="Tracé 9950"
          d="M479.043,584.676a174.294,174.294,0,0,0,37.132,5.359,46.5,46.5,0,0,0,5.689-.039c4.162-.35,7.727-1.658,11.7-2.373,1.909-.343,4.035-.593,5.956-.964q-.666-.826-1.356-1.632c-4.143.35-8.351,1.5-12.544,2.028-7.128.906-15.114-.1-20.518-2.6-2.622-1.21-4.63-2.721-7.242-3.937a3.374,3.374,0,0,0-1.137-.348,3.955,3.955,0,0,0-2.144.556c-4.383,2.213-10.746,4.011-16.653,3.021C477.483,584.094,478.319,584.487,479.043,584.676Z"
          transform="translate(-284.098 -274.941)"
          fill="#fff"
        />
        <path
          id="Tracé_9951"
          data-name="Tracé 9951"
          d="M441.424,597.863l-.162-.027a4.411,4.411,0,0,0,.638-.481Z"
          transform="translate(-272.615 -280.342)"
          fill="#fff"
        />
        <path
          id="Tracé_9952"
          data-name="Tracé 9952"
          d="M389.937,602.321q3.7.3,7.439.44a46.868,46.868,0,0,0,5.689-.039c4.162-.352,7.727-1.658,11.7-2.373,3.639-.654,8.06-.969,10.37-2.421-5.971-1.034-12.157,1.07-18.314,1.853a43.734,43.734,0,0,1-14.925-.737Q390.871,600.654,389.937,602.321Z"
          transform="translate(-256.486 -280.434)"
          fill="#fff"
        />
        <path
          id="Tracé_9953"
          data-name="Tracé 9953"
          d="M433.455,740.036c.59.322,1.186.631,1.783.926.213.1.432.206.645.315.178.082.357.172.535.254.055.027.1.048.151.075.151.069.295.137.446.206s.329.151.487.226c.185.082.363.165.549.24.686.309,1.378.6,2.071.885a72.592,72.592,0,0,0,7.6,2.633c.116.034.24.069.363.1q1.656.463,3.333.844,2.932.679,5.918,1.111h.014l.713.1c.021,0,.041.007.069.007,0,.007,0,.007.007,0l.789.1a.174.174,0,0,0,.055.007c.247.034.5.062.747.089l.8.082.617.062a.133.133,0,0,0,.055.007c.185.014.37.034.555.048h.028l.48.041c1.913.151,3.833.219,5.781.219,2.105,0,4.2-.082,6.261-.26h.021l1.323-.123c.117-.014.226-.021.343-.034.021,0,.048-.007.068-.007s.069-.007.11-.014a.17.17,0,0,0,.055-.007c.151-.014.3-.034.459-.048l.514-.062c.171-.021.343-.048.514-.069.041-.007.075-.007.117-.014.123-.014.247-.034.37-.055l.178-.021c.123-.021.24-.034.364-.055h.007a72.484,72.484,0,0,0,11.109-2.5c.192-.062.384-.117.576-.178a27.551,27.551,0,0,0-15.107-19.1,6.512,6.512,0,0,0,1.872-3.333,6.374,6.374,0,0,0-.878-4.814,6.15,6.15,0,0,0-3.881-2.661l-10.163-2.126a6.325,6.325,0,0,0-7.406,4.937,6.693,6.693,0,0,0-.137,1.522C444.948,726.108,437.905,732.863,433.455,740.036Z"
          transform="translate(-270.162 -316.689)"
          fill="#6c63ff"
        />
        <circle
          id="Ellipse_4892"
          data-name="Ellipse 4892"
          cx="21.173"
          cy="21.173"
          r="21.173"
          transform="translate(172.127 350.086)"
          fill="#ffb8b8"
        />
        <path
          id="Tracé_9954"
          data-name="Tracé 9954"
          d="M453.071,681.258c-2.258-1.542-4.563-4.506-6.1-6.727a25.424,25.424,0,0,1-3.926-20.3,7.751,7.751,0,0,1,1.823-3.734,3.333,3.333,0,0,1,3.843-.757,6.948,6.948,0,0,1,.282-5.513,12.246,12.246,0,0,1,3.62-4.312,20.392,20.392,0,0,1,20.767-2.459c1.323.613-.85-4.12.535-3.664a5.643,5.643,0,0,0,4.26-.075c1.3-.655,5.617,3.239,5.118,1.869a6.43,6.43,0,0,1,1.489,10.768,35.425,35.425,0,0,1-3.653,2.237,10.49,10.49,0,0,0-3.209,13.537,13.9,13.9,0,0,0-4.09-1.777,4.7,4.7,0,0,0-4.186,1.007,5.284,5.284,0,0,0-1.28,3.988c.047,1.437.389,2.852.428,4.289.113,4.217,2.371,12.234-.9,14.475C465.31,685.881,456.154,683.364,453.071,681.258Z"
          transform="translate(-272.969 -291.745)"
          fill="#2f2e41"
        />
        <path
          id="Tracé_9959"
          data-name="Tracé 9959"
          d="M494.16,493.534a3.382,3.382,0,0,1-1.3-.263,3.285,3.285,0,0,1-2.06-3.083v-3.351a2.654,2.654,0,0,0-2.651-2.652,3.341,3.341,0,0,1-3.337-3.337V434.936a3.341,3.341,0,0,1,3.337-3.337H640.265a3.341,3.341,0,0,1,3.337,3.337V480.85a3.341,3.341,0,0,1-3.337,3.337H505.959a2.635,2.635,0,0,0-1.875.776l-7.586,7.586A3.29,3.29,0,0,1,494.16,493.534Z"
          transform="translate(-286.302 -228.251)"
          fill="#fff"
        />
        <path
          id="Tracé_9960"
          data-name="Tracé 9960"
          d="M493.845,493.906a4.054,4.054,0,0,1-1.561-.315,3.96,3.96,0,0,1-2.483-3.716v-3.351a1.968,1.968,0,0,0-1.965-1.966,4.028,4.028,0,0,1-4.023-4.023V434.621a4.027,4.027,0,0,1,4.023-4.023H639.951a4.028,4.028,0,0,1,4.023,4.023v45.914a4.028,4.028,0,0,1-4.023,4.023H505.645a1.952,1.952,0,0,0-1.39.576l-7.586,7.585A3.974,3.974,0,0,1,493.845,493.906Zm-6.01-61.936a2.654,2.654,0,0,0-2.651,2.652v45.914a2.655,2.655,0,0,0,2.652,2.652,3.341,3.341,0,0,1,3.337,3.338v3.351a2.652,2.652,0,0,0,4.526,1.874l7.586-7.585a3.314,3.314,0,0,1,2.36-.978H639.951a2.654,2.654,0,0,0,2.652-2.652V434.621a2.654,2.654,0,0,0-2.651-2.651Z"
          transform="translate(-285.987 -227.937)"
          fill="#3f3d56"
        />
        <path
          id="Tracé_9961"
          data-name="Tracé 9961"
          d="M635.1,460.282H511.751a1.777,1.777,0,1,1,0-3.553H635.1a1.777,1.777,0,0,1,0,3.553Z"
          transform="translate(-294.209 -236.148)"
          fill="#6c63ff"
        />
        <path
          id="Tracé_9962"
          data-name="Tracé 9962"
          d="M634.874,471.289H511.751a1.777,1.777,0,1,1,0-3.553H634.874a1.777,1.777,0,0,1,0,3.553Z"
          transform="translate(-294.209 -239.607)"
          fill="#e6e6e6"
        />
        <path
          id="Tracé_9963"
          data-name="Tracé 9963"
          d="M634.752,482.3h-123a1.777,1.777,0,1,1,0-3.553h123a1.777,1.777,0,0,1,0,3.553Z"
          transform="translate(-294.209 -243.066)"
          fill="#e6e6e6"
        />
        <path
          id="Tracé_9964"
          data-name="Tracé 9964"
          d="M908,387.353c0,1.666-.055,3.333-.172,4.985-.123,1.975-.336,3.936-.624,5.884a73.534,73.534,0,0,1-5.5,19.016l-.411.905-.206.453c-.069.151-.144.3-.213.446-.1.2-.185.391-.281.583-.117.24-.233.48-.357.72-.014.027-.027.062-.048.1-.1.206-.2.4-.309.61a1.169,1.169,0,0,1-.068.13c-.117.233-.24.473-.364.706s-.267.5-.4.747c-.329.61-.672,1.214-1.022,1.817-.1.178-.206.357-.315.535s-.192.329-.295.494c-.068.11-.137.226-.206.336-.11.185-.219.363-.336.549-.254.4-.514.809-.768,1.214H896.1c-.117.185-.24.37-.364.549v.007c-.363.549-.741,1.1-1.118,1.639l-.005,0a.007.007,0,0,0,0,0c-.3.439-.617.864-.926,1.289v.007c-.206.267-.4.542-.61.809-.165.219-.336.446-.507.665-.034.048-.075.089-.11.137v.007c-.048.062-.1.117-.144.178q-1.09,1.4-2.249,2.736l-.123.144c-.041.048-.089.1-.13.151-.068.075-.13.151-.2.226s-.13.151-.2.226a74.487,74.487,0,0,1-13.6,11.994c-.665.459-1.344.905-2.023,1.337-.171.11-.343.219-.514.322-.048.034-.1.069-.151.1-.1.055-.185.11-.281.171s-.178.11-.274.165c-.363.226-.734.446-1.1.665-.089.055-.185.11-.281.165s-.185.1-.281.158c0,.007,0,.007-.007.007h-.007v.007h-.007q-.689.4-1.4.782c-.254.137-.514.281-.775.411-.59.322-1.186.631-1.783.926-.213.1-.432.206-.645.315-.178.082-.357.171-.535.254-.055.027-.1.048-.151.075-.151.069-.295.137-.446.206s-.329.151-.487.226c-.185.082-.363.165-.549.24-.686.309-1.378.6-2.071.885a72.609,72.609,0,0,1-7.6,2.633c-.117.034-.24.069-.364.1q-1.656.463-3.333.844-2.932.679-5.918,1.111h-.014l-.713.1c-.021,0-.041.007-.068.007,0,.007,0,.007-.007,0l-.789.1a.175.175,0,0,1-.055.007c-.247.034-.5.062-.747.089l-.8.082-.617.062a.133.133,0,0,1-.055.007c-.185.014-.37.034-.555.048h-.027l-.48.041c-1.913.151-3.833.219-5.781.219-2.105,0-4.2-.082-6.261-.261h-.021l-1.323-.123c-.117-.014-.226-.021-.343-.034-.021,0-.048-.007-.069-.007s-.068-.007-.11-.014a.17.17,0,0,1-.055-.007c-.151-.014-.3-.034-.459-.048l-.514-.062c-.171-.021-.343-.048-.514-.069-.041-.007-.075-.007-.117-.014-.123-.014-.247-.034-.37-.055l-.178-.021c-.123-.021-.24-.034-.363-.055h-.007a72.489,72.489,0,0,1-11.109-2.5c-.192-.062-.384-.117-.576-.178-.007,0-.014-.007-.021-.007-.055-.021-.117-.034-.171-.055-.514-.165-1.022-.336-1.529-.514-.7-.233-1.392-.487-2.085-.747-.185-.075-.37-.144-.555-.219-.377-.144-.748-.295-1.118-.446-.631-.254-1.262-.521-1.886-.8-.583-.261-1.159-.521-1.735-.8-.014-.007-.034-.007-.048-.021-.13-.062-.261-.123-.384-.185h-.007a73.509,73.509,0,0,1-9.113-5.2q-1.4-.936-2.757-1.934c-.727-.542-1.44-1.09-2.153-1.653a74.254,74.254,0,0,1-9.731-9.3V435.9c-.213-.233-.411-.473-.617-.713-.034-.034-.062-.069-.089-.1-.13-.158-.254-.309-.384-.459v-.007c-.171-.2-.343-.4-.507-.61l-.11-.13v-.007c-.137-.165-.267-.329-.4-.5-.068-.082-.13-.165-.2-.247v-.007c-.4-.507-.8-1.015-1.186-1.536-.1-.137-.206-.281-.315-.425-.494-.665-.974-1.344-1.44-2.023v-.007c-.178-.254-.35-.514-.528-.768l-.514-.782c-.172-.274-.35-.542-.521-.816l-.021-.041c-.171-.261-.343-.535-.507-.8-.13-.219-.261-.432-.391-.645-.082-.144-.171-.288-.254-.439a1.657,1.657,0,0,1-.089-.144l-.576-1.008c-.226-.391-.446-.789-.665-1.186-.082-.165-.171-.329-.261-.494-.034-.055-.062-.11-.089-.165-.1-.192-.206-.391-.3-.59s-.206-.391-.309-.59-.2-.391-.295-.59c-.075-.151-.144-.3-.219-.453a.15.15,0,0,0-.021-.034c-.034-.075-.069-.144-.1-.213a.145.145,0,0,1-.021-.034c-.075-.151-.144-.309-.219-.459-.1-.2-.185-.4-.281-.6-.062-.137-.13-.281-.192-.425-.089-.2-.185-.4-.267-.6s-.185-.411-.274-.624a1.549,1.549,0,0,1-.069-.158c-.048-.1-.082-.192-.123-.288-.11-.254-.219-.514-.322-.768-.123-.288-.24-.583-.35-.871-.11-.267-.213-.542-.315-.816l-.041-.1a74.274,74.274,0,0,1-3.621-12.981v-.007A75.037,75.037,0,0,1,760.45,393c-.007-.144-.021-.281-.027-.418-.123-1.735-.178-3.477-.178-5.225,0-.775.014-1.543.034-2.311a73.527,73.527,0,0,1,16.307-44.025c.219-.274.439-.549.665-.823s.459-.542.686-.809A73.888,73.888,0,0,1,896.6,347.909c.336.535.672,1.077.994,1.618s.645,1.1.96,1.653A73.563,73.563,0,0,1,908,387.353Z"
          transform="translate(-372.858 -191.13)"
          fill="#f2f2f2"
        />
        <path
          id="Tracé_9965"
          data-name="Tracé 9965"
          d="M844.543,348.676a174.292,174.292,0,0,1-37.132,5.359,46.493,46.493,0,0,1-5.689-.039c-4.162-.35-7.727-1.658-11.7-2.373-1.909-.343-4.035-.593-5.956-.964q.666-.826,1.356-1.632c4.143.35,8.351,1.5,12.544,2.028,7.128.906,15.114-.105,20.518-2.6,2.622-1.21,4.63-2.721,7.242-3.937a3.375,3.375,0,0,1,1.137-.348,3.955,3.955,0,0,1,2.144.556c4.383,2.213,10.746,4.011,16.653,3.021C846.1,348.094,845.268,348.487,844.543,348.676Z"
          transform="translate(-380.345 -200.776)"
          fill="#fff"
        />
        <path
          id="Tracé_9966"
          data-name="Tracé 9966"
          d="M910.153,361.863l.162-.027a4.4,4.4,0,0,1-.638-.481Z"
          transform="translate(-419.818 -206.177)"
          fill="#fff"
        />
        <path
          id="Tracé_9967"
          data-name="Tracé 9967"
          d="M945.8,366.321q-3.7.3-7.439.44a46.868,46.868,0,0,1-5.689-.039c-4.162-.352-7.727-1.658-11.7-2.373-3.639-.654-8.06-.969-10.37-2.421,5.971-1.034,12.157,1.07,18.314,1.853a43.731,43.731,0,0,0,14.925-.737Q944.869,364.654,945.8,366.321Z"
          transform="translate(-420.111 -206.269)"
          fill="#fff"
        />
        <ellipse
          id="Ellipse_4896"
          data-name="Ellipse 4896"
          cx="22.19"
          cy="22.684"
          rx="22.19"
          ry="22.684"
          transform="translate(430.743 183.181)"
          fill="#ffb6b6"
        />
        <path
          id="Tracé_9968"
          data-name="Tracé 9968"
          d="M892.3,504.036c-.59.322-1.186.631-1.783.926-.213.1-.432.206-.645.315-.178.082-.357.171-.535.254-.055.027-.1.048-.151.075-.151.069-.295.137-.446.206s-.329.151-.487.226c-.185.082-.363.165-.549.24-.686.309-1.378.6-2.071.885a72.582,72.582,0,0,1-7.6,2.633c-.117.034-.24.069-.363.1q-1.656.463-3.333.843-2.932.679-5.918,1.111h-.014l-.713.1c-.021,0-.041.007-.068.007,0,.007,0,.007-.007,0l-.789.1a.171.171,0,0,1-.055.007c-.247.034-.5.062-.747.089l-.8.082-.617.062a.133.133,0,0,1-.055.007c-.185.014-.37.034-.555.048h-.027l-.48.041c-1.913.151-3.833.219-5.781.219-2.105,0-4.2-.082-6.261-.261h-.021l-1.324-.123c-.117-.014-.226-.021-.343-.034-.021,0-.048-.007-.069-.007s-.069-.007-.11-.014a.167.167,0,0,1-.055-.007c-.151-.014-.3-.034-.459-.048l-.514-.062c-.171-.021-.343-.048-.514-.069-.041-.007-.075-.007-.117-.014-.123-.014-.247-.034-.37-.055l-.178-.021c-.123-.021-.24-.034-.363-.055h-.007a72.493,72.493,0,0,1-11.109-2.5c-.192-.062-.384-.117-.576-.178a27.551,27.551,0,0,1,15.107-19.1,6.512,6.512,0,0,1-1.872-3.333,6.373,6.373,0,0,1,.878-4.814,6.15,6.15,0,0,1,3.881-2.661l10.163-2.126a6.325,6.325,0,0,1,7.406,4.937,6.7,6.7,0,0,1,.137,1.522C880.81,490.108,887.853,496.863,892.3,504.036Z"
          transform="translate(-396.453 -242.524)"
          fill="#6c63ff"
        />
        <path
          id="Tracé_9969"
          data-name="Tracé 9969"
          d="M902.844,410.054c-3.772-4.4-5.565-10.234-8.58-15.229s-8.262-9.465-13.806-8.3c-3.821.8-6.774,4.173-8.269,7.932s-1.775,7.9-2.037,11.966c.093-8.346-5.406-16.437-12.981-19.1a19.117,19.117,0,0,0-21.4,7.013,11.566,11.566,0,0,0-15.362-.322,12.884,12.884,0,0,0-2.068,15.9,11.645,11.645,0,0,0,14.887,3.97l1.759,1.618a7.626,7.626,0,0,0,4.158,8.857c2.617,1.057,6.312.881,7.292,3.628.684,1.919-.595,3.968-1.956,5.443s-2.976,3-3.14,5.039c-.247,3.079,2.935,5.236,5.828,5.886a18.17,18.17,0,0,0,18.734-7.819q.116-.178.253-.357a26.935,26.935,0,0,0,5.418-20.6c-.226-1.423,0-2.481.983-2.818,4.24-1.456,16.118,1.6,19.713,4.363s6.474,6.418,9.936,9.359,7.875,5.209,12.272,4.408c3.521-.641,6.517-3.2,8.532-6.281a37.816,37.816,0,0,0,4.213-10.25A19.83,19.83,0,0,1,902.844,410.054Z"
          transform="translate(-390.534 -214.027)"
          fill="#2f2e41"
        />
        <path
          id="Tracé_9970"
          data-name="Tracé 9970"
          d="M278.155,320.353c0,1.666.055,3.333.171,4.985.123,1.975.336,3.936.624,5.884a73.547,73.547,0,0,0,5.5,19.016l.411.905.206.453c.069.151.144.3.213.446.1.2.185.391.281.583.117.24.233.48.357.72.014.027.027.062.048.1.1.206.2.4.309.61a1.191,1.191,0,0,0,.069.13c.117.233.24.473.363.706s.267.5.4.747c.329.61.672,1.214,1.022,1.817.1.178.206.357.315.535s.192.329.295.494c.069.11.137.226.206.336.11.185.219.363.336.549.254.4.514.809.768,1.214h.007c.117.185.24.37.363.549v.007c.363.549.741,1.1,1.118,1.639l0,0a.007.007,0,0,1,0,0c.3.439.617.864.926,1.289v.007c.206.267.4.542.61.809.165.219.336.446.507.665.034.048.075.089.11.137v.007c.048.062.1.117.144.178q1.09,1.4,2.249,2.736l.123.144c.041.048.089.1.13.151.069.075.13.151.2.226s.13.151.2.226a74.484,74.484,0,0,0,13.6,11.994c.665.459,1.344.905,2.023,1.337.171.11.343.219.514.322.048.034.1.069.151.1.1.055.185.11.281.171s.178.11.274.165c.363.226.734.446,1.1.665.089.055.185.11.281.165s.185.1.281.158c0,.007,0,.007.007.007h.007v.007h.007q.689.4,1.4.782c.254.137.514.281.775.411.59.322,1.186.631,1.783.926.213.1.432.206.645.315.178.082.357.171.535.254.055.027.1.048.151.075.151.069.295.137.446.206s.329.151.487.226c.185.082.363.165.549.24.686.309,1.378.6,2.071.885a72.608,72.608,0,0,0,7.6,2.633c.117.034.24.069.363.1q1.656.463,3.333.843,2.932.679,5.918,1.111h.014l.713.1c.021,0,.041.007.069.007,0,.007,0,.007.007,0l.789.1a.172.172,0,0,0,.055.007c.247.034.5.062.747.089l.8.082.617.062a.133.133,0,0,0,.055.007c.185.014.37.034.555.048h.027l.48.041c1.913.151,3.833.219,5.781.219,2.105,0,4.2-.082,6.261-.261h.021l1.323-.123c.117-.014.226-.021.343-.034.021,0,.048-.007.069-.007s.069-.007.11-.014a.17.17,0,0,0,.055-.007c.151-.014.3-.034.46-.048l.514-.062c.171-.021.343-.048.514-.069.041-.007.075-.007.117-.014.123-.014.247-.034.37-.055l.178-.021c.123-.021.24-.034.363-.055h.007a72.489,72.489,0,0,0,11.109-2.5c.192-.062.384-.117.576-.178.007,0,.014-.007.021-.007.055-.021.117-.034.171-.055.514-.165,1.022-.336,1.529-.514.7-.233,1.392-.487,2.085-.747.185-.075.37-.144.555-.219.377-.144.747-.295,1.118-.446.631-.254,1.262-.521,1.886-.8.583-.261,1.159-.521,1.735-.8.014-.007.034-.007.048-.021.13-.062.261-.123.384-.185h.007a73.511,73.511,0,0,0,9.114-5.2q1.4-.936,2.757-1.934c.727-.542,1.44-1.09,2.153-1.653a74.252,74.252,0,0,0,9.731-9.3V368.9c.213-.233.411-.473.617-.713.034-.034.062-.069.089-.1.13-.158.254-.309.384-.459v-.007c.171-.2.343-.4.507-.61l.11-.13v-.007c.137-.165.267-.329.4-.5.069-.082.13-.165.2-.247v-.007c.4-.507.8-1.015,1.186-1.536.1-.137.206-.281.315-.425.494-.665.974-1.344,1.44-2.023v-.007c.178-.254.35-.514.528-.768l.514-.782c.171-.274.35-.542.521-.816l.021-.041c.171-.261.343-.535.507-.8.13-.219.261-.432.391-.645.082-.144.171-.288.254-.439a1.642,1.642,0,0,0,.089-.144l.576-1.008c.226-.391.446-.789.665-1.186.082-.165.171-.329.261-.494.034-.055.062-.11.089-.165.1-.192.206-.391.3-.59s.206-.391.309-.59.2-.391.295-.59c.075-.151.144-.3.219-.453a.149.149,0,0,1,.021-.034c.034-.075.069-.144.1-.213a.149.149,0,0,0,.021-.034c.075-.151.144-.309.219-.459.1-.2.185-.4.281-.6.062-.137.13-.281.192-.425.089-.2.185-.4.267-.6s.185-.411.274-.624a1.584,1.584,0,0,0,.069-.158c.048-.1.082-.192.123-.288.11-.254.219-.514.322-.768.123-.288.24-.583.35-.871.11-.267.213-.542.315-.816l.041-.1a74.276,74.276,0,0,0,3.621-12.981v-.007a75.027,75.027,0,0,0,.981-7.639c.007-.144.021-.281.027-.418.123-1.735.178-3.477.178-5.225,0-.775-.014-1.543-.034-2.311a73.527,73.527,0,0,0-16.307-44.025c-.219-.274-.439-.549-.665-.823s-.459-.542-.686-.809a73.888,73.888,0,0,0-118.661,8.524c-.336.535-.672,1.077-.994,1.618s-.645,1.1-.96,1.653a73.564,73.564,0,0,0-9.45,36.173Z"
          transform="translate(-221.358 -170.075)"
          fill="#f2f2f2"
        />
        <path
          id="Tracé_9971"
          data-name="Tracé 9971"
          d="M381.043,281.676a174.291,174.291,0,0,0,37.132,5.359,46.5,46.5,0,0,0,5.689-.039c4.162-.35,7.727-1.658,11.7-2.373,1.909-.343,4.035-.593,5.956-.964q-.666-.826-1.356-1.632c-4.143.35-8.351,1.5-12.544,2.028-7.128.906-15.114-.105-20.518-2.6-2.622-1.21-4.63-2.721-7.242-3.937a3.377,3.377,0,0,0-1.137-.348,3.956,3.956,0,0,0-2.144.556c-4.383,2.213-10.746,4.011-16.653,3.021C379.483,281.094,380.319,281.487,381.043,281.676Z"
          transform="translate(-253.301 -179.721)"
          fill="#fff"
        />
        <path
          id="Tracé_9972"
          data-name="Tracé 9972"
          d="M343.424,294.863l-.162-.027a4.4,4.4,0,0,0,.638-.481Z"
          transform="translate(-241.818 -185.121)"
          fill="#fff"
        />
        <path
          id="Tracé_9973"
          data-name="Tracé 9973"
          d="M291.937,299.321q3.7.3,7.439.44a46.861,46.861,0,0,0,5.689-.039c4.162-.352,7.727-1.658,11.7-2.373,3.639-.654,8.06-.969,10.37-2.421-5.971-1.034-12.157,1.07-18.314,1.853a43.732,43.732,0,0,1-14.925-.737Q292.871,297.654,291.937,299.321Z"
          transform="translate(-225.689 -185.214)"
          fill="#fff"
        />
        <path
          id="Tracé_9974"
          data-name="Tracé 9974"
          d="M335.455,437.036c.59.322,1.186.631,1.783.926.213.1.432.206.645.315.178.082.357.171.535.254.055.027.1.048.151.075.151.069.295.137.446.206s.329.151.487.226c.185.082.363.165.549.24.686.309,1.378.6,2.071.885a72.6,72.6,0,0,0,7.6,2.633c.117.034.24.069.363.1q1.656.463,3.333.843,2.932.679,5.918,1.111h.014l.713.1c.021,0,.041.007.069.007,0,.007,0,.007.007,0l.789.1a.17.17,0,0,0,.055.007c.247.034.5.062.747.089l.8.082.617.062a.132.132,0,0,0,.055.007c.185.014.37.034.555.048h.027l.48.041c1.913.151,3.833.219,5.781.219,2.105,0,4.2-.082,6.261-.261h.021l1.323-.124c.117-.014.226-.021.343-.034.021,0,.048-.007.069-.007s.069-.007.11-.014a.17.17,0,0,0,.055-.007c.151-.014.3-.034.46-.048l.514-.062c.171-.021.343-.048.514-.069.041-.007.075-.007.117-.014.123-.014.247-.034.37-.055l.178-.021c.123-.021.24-.034.363-.055h.007a72.486,72.486,0,0,0,11.109-2.5c.192-.062.384-.117.576-.178a27.551,27.551,0,0,0-15.107-19.1,6.513,6.513,0,0,0,1.872-3.333,6.374,6.374,0,0,0-.878-4.814,6.15,6.15,0,0,0-3.881-2.661l-10.163-2.126a6.325,6.325,0,0,0-7.406,4.937,6.7,6.7,0,0,0-.137,1.522C346.948,423.108,339.905,429.863,335.455,437.036Z"
          transform="translate(-239.365 -221.469)"
          fill="#6c63ff"
        />
        <circle
          id="Ellipse_4897"
          data-name="Ellipse 4897"
          cx="24.737"
          cy="24.737"
          r="24.737"
          transform="translate(111.557 132.332)"
          fill="#9e616a"
        />
        <path
          id="Tracé_9975"
          data-name="Tracé 9975"
          d="M375.839,373.277c-6.193,1.673-13.02-.551-17.853-4.769s-7.856-10.195-9.6-16.369c-1.276-4.521-1.881-9.541.133-13.785s7.431-7.109,11.612-4.964c-2.579-3-1.29-7.974,1.721-10.544s7.147-3.307,11.086-3.71c5.716-.585,11.621-.65,17.06,1.2s10.382,5.9,12.084,11.389a8.668,8.668,0,0,0,10.339-2.334,7.853,7.853,0,0,1-4.327,8.515l8.334-2.7c1.433,3.034-1.078,6.789-4.29,7.76s-6.679-.09-9.726-1.494-6-3.178-9.312-3.726-7.2.516-8.73,3.5c-.8,1.564-.844,3.4-1.31,5.09s-1.645,3.452-3.4,3.59c-1.107.088-2.191-.5-3.294-.381a3.55,3.55,0,0,0-2.78,2.716,10.422,10.422,0,0,0-.01,4.1l2.117,16.182Z"
          transform="translate(-243.06 -192.794)"
          fill="#2f2e41"
        />
      </g>
    </g>
  </svg>
);

export const SvgCheckEchanger = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <g id="Groupe_1206" data-name="Groupe 1206" transform="translate(-329 -7161)">
      <circle
        id="Ellipse_4810"
        data-name="Ellipse 4810"
        cx="20"
        cy="20"
        r="20"
        transform="translate(329 7161)"
        fill="#372e5e"
      />
      <path
        id="Tracé_3307"
        data-name="Tracé 3307"
        d="M-17970.424-8137.042l9.361,9.361,13.373-13.374"
        transform="translate(18308 15315.326)"
        fill="none"
        stroke="#fff"
        strokeWidth="5"
      />
    </g>
  </svg>
);

export const SvgEchangerBg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1921.25 937.375">
    <defs>
      <linearGradient id="0bfxvoss0a" x1=".5" x2=".5" y2="1" gradientUnits="objectBoundingBox">
        <stop offset="0" stopColor="#5833ff" />
        <stop offset="1" stopColor="#027fc1" stopOpacity="0" />
      </linearGradient>
    </defs>
    <g data-name="Groupe 8865">
      <path data-name="Tracé 9977" d="M0 0h1920v937H0z" transform="translate(1.25 .375)" style={{ fill: '#17007d' }} />
      <path data-name="Tracé 2904" d="M0 0h1921.25v361.527H0z" style={{ opacity: '.77', fill: "url('#0bfxvoss0a')" }} />
    </g>
  </svg>
);

export const SvgAcademyLogo = ({ color = '#fff' }) => (
  <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 154.89 32.48">
    <g>
      <circle cx="14.56" cy="16.25" r="1.89" style={{ fill: '#ffd166', strokeWidth: 0 }} />
      <g>
        <path
          d="m2.07,12.12c0,5.28,0,11.64,0,14.73,0,3.35,1.63,5.51,3.68,5.54.02,0,.04,0,.06,0,1.03,0,1.69-.4,2.23-.98.97-1.04,1.51-2.76,1.51-4.53v-7.46c-3.01-1.25-5.82-4.05-7.49-7.29Z"
          style={{
            fill: '#364ebf',
            strokeWidth: 0,
          }}
        />
        <path
          d="m14.55,19.41c-.06-.22-.32-.34-.53-.42-2.07-.61-3.24-2.35-3.38-4.55-.53-4.23,1.15-9.65-2.1-13.12C6.32-.91,2.56-.21,1.23,2.6c-3.32,7.12,4.96,18.54,12.7,17.41.3-.05.68-.26.61-.58v-.02Z"
          style={{
            fill: '#2fd7ca',
            strokeWidth: 0,
          }}
        />
      </g>
      <g>
        <path
          d="m27.07,20.27c0-5.28,0-11.64,0-14.73,0-3.35-1.63-5.51-3.68-5.54-.02,0-.04,0-.06,0-1.03,0-1.69.4-2.23.98-.97,1.04-1.51,2.76-1.51,4.53v7.46c3.01,1.25,5.82,4.05,7.49,7.29Z"
          style={{
            fill: '#364ebf',
            strokeWidth: 0,
          }}
        />
        <path
          d="m14.66,13.13c.13.15.35.22.54.29,2,.59,3.18,2.36,3.31,4.5.51,4.07-1.01,9.16,1.72,12.71,2.12,2.73,6.31,2.18,7.72-.93,3.18-7.17-4.94-18.32-12.69-17.32-.37.03-.91.33-.6.73v.02Z"
          style={{
            fill: '#2fd7ca',
            strokeWidth: 0,
          }}
        />
      </g>
    </g>
    <text
      transform="translate(35.28 15.21)"
      style={{
        fill: color,
        fontFamily: 'Montserrat-SemiBold, Montserrat',
        fontSize: '17px',
        fontWeight: 600,
      }}
    >
      <tspan x="0" y="0">
        Hap
      </tspan>
      <tspan x="35.75" y="0" style={{ letterSpacing: '-.01em' }}>
        p
      </tspan>
      <tspan x="47.16" y="0">
        y
      </tspan>
      <tspan x="56.98" y="0" style={{ letterSpacing: '0em' }}>
        n
      </tspan>
      <tspan x="68.71" y="0" style={{ letterSpacing: '0em' }}>
        eu
      </tspan>
      <tspan x="90.86" y="0" style={{ letterSpacing: '0em' }}>
        r
      </tspan>
      <tspan x="97.83" y="0">
        on
      </tspan>
    </text>
    <text
      transform="translate(35.93 28.75)"
      style={{
        fill: '#ffe8ae',
        fontFamily: 'Montserrat-SemiBold, Montserrat',
        fontSize: '10px',
        fontWeight: 600,
      }}
    >
      <tspan x="0" y="0" style={{ letterSpacing: '0em' }}>
        A
      </tspan>
      <tspan x="7.39" y="0" style={{ letterSpacing: '-.02em' }}>
        C
      </tspan>
      <tspan x="14.51" y="0" style={{ letterSpacing: '0em' }}>
        ADEMY
      </tspan>
    </text>
  </svg>
);

export const SvgVerticalLogo = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Calque_1"
    data-name="Calque 1"
    viewBox="0 0 234.73 111.73"
    width="100%"
    height="100%"
  >
    <g>
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m21.12,81.14v23.77h-4.41v-10.19H4.41v10.19H0v-23.77h4.41v9.81h12.29v-9.81h4.41Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m42.27,94.28v10.63h-4.01v-2.21c-1.02,1.56-2.99,2.44-5.7,2.44-4.14,0-6.76-2.27-6.76-5.43s2.04-5.4,7.54-5.4h4.69v-.27c0-2.48-1.49-3.94-4.52-3.94-2.04,0-4.14.68-5.5,1.8l-1.66-3.09c1.94-1.49,4.75-2.24,7.67-2.24,5.23,0,8.25,2.48,8.25,7.71Zm-4.24,4.96v-2.11h-4.38c-2.89,0-3.67,1.09-3.67,2.41,0,1.53,1.29,2.51,3.46,2.51s3.87-.95,4.58-2.82Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m66.95,95.84c0,5.64-3.91,9.3-9.2,9.3-2.31,0-4.35-.78-5.81-2.44v8.79h-4.24v-24.72h4.04v2.38c1.43-1.73,3.53-2.58,6.01-2.58,5.3,0,9.2,3.67,9.2,9.27Zm-4.31,0c0-3.46-2.31-5.67-5.36-5.67s-5.4,2.21-5.4,5.67,2.34,5.67,5.4,5.67,5.36-2.21,5.36-5.67Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m90.24,95.84c0,5.64-3.9,9.3-9.2,9.3-2.31,0-4.35-.78-5.81-2.44v8.79h-4.24v-24.72h4.04v2.38c1.43-1.73,3.53-2.58,6.01-2.58,5.3,0,9.2,3.67,9.2,9.27Zm-4.31,0c0-3.46-2.31-5.67-5.36-5.67s-5.4,2.21-5.4,5.67,2.34,5.67,5.4,5.67,5.36-2.21,5.36-5.67Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m110.75,86.77l-8.49,19.59c-1.66,4.11-3.97,5.36-7,5.36-1.8,0-3.7-.61-4.86-1.66l1.7-3.12c.81.78,1.97,1.26,3.12,1.26,1.49,0,2.38-.71,3.19-2.51l.31-.71-7.91-18.2h4.41l5.7,13.41,5.74-13.41h4.08Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m131.25,94.51v10.39h-4.24v-9.85c0-3.23-1.6-4.79-4.31-4.79-3.02,0-5.06,1.83-5.06,5.47v9.17h-4.24v-18.13h4.04v2.34c1.39-1.66,3.6-2.55,6.25-2.55,4.35,0,7.57,2.48,7.57,7.95Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m153.8,97.2h-14.23c.51,2.65,2.72,4.35,5.87,4.35,2.04,0,3.63-.65,4.92-1.97l2.27,2.61c-1.63,1.94-4.18,2.95-7.3,2.95-6.08,0-10.02-3.9-10.02-9.3s3.97-9.27,9.37-9.27,9.17,3.7,9.17,9.37c0,.34-.03.85-.07,1.26Zm-14.26-2.82h10.29c-.34-2.61-2.34-4.41-5.13-4.41s-4.75,1.77-5.16,4.41Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m175.49,86.77v18.13h-4.04v-2.31c-1.36,1.66-3.5,2.55-5.84,2.55-4.65,0-7.81-2.55-7.81-8.01v-10.36h4.24v9.78c0,3.29,1.56,4.86,4.24,4.86,2.95,0,4.96-1.83,4.96-5.47v-9.17h4.24Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m191.55,86.57v4.04c-.37-.07-.68-.1-.98-.1-3.23,0-5.26,1.9-5.26,5.6v8.79h-4.24v-18.13h4.04v2.65c1.22-1.9,3.43-2.85,6.45-2.85Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m193.48,95.84c0-5.43,4.07-9.27,9.64-9.27s9.68,3.84,9.68,9.27-4.04,9.3-9.68,9.3-9.64-3.87-9.64-9.3Zm15.04,0c0-3.46-2.31-5.67-5.4-5.67s-5.37,2.21-5.37,5.67,2.31,5.67,5.37,5.67,5.4-2.21,5.4-5.67Z"
      />
      <path
        style={{ fill: '#120032', strokeWidth: 0 }}
        d="m234.73,94.51v10.39h-4.24v-9.85c0-3.23-1.6-4.79-4.31-4.79-3.02,0-5.06,1.83-5.06,5.47v9.17h-4.24v-18.13h4.04v2.34c1.39-1.66,3.6-2.55,6.25-2.55,4.35,0,7.57,2.48,7.57,7.95Z"
      />
    </g>
    <g>
      <circle style={{ fill: '#ffd166', strokeWidth: 0 }} cx="118.06" cy="34.18" r="3.88" />
      <path
        style={{ fill: '#364ebf', strokeWidth: 0 }}
        d="m91.15,27.33c0,10.28,0,22.3,0,28.22,0,6.66,3.15,10.94,7.09,11.01.04,0,.08,0,.12,0,1.99,0,3.26-.8,4.3-1.95,1.87-2.08,2.91-5.48,2.91-9v-13.68c-.37-.16-.73-.33-1.1-.52-5.42-2.76-10.22-8.02-13.32-14.08Z"
      />
      <path
        style={{ fill: '#2fd7ca', strokeWidth: 0 }}
        d="m118.06,41.86c-.03-.17-.23-.31-.54-.42-.91-.28-2.01-.28-2.96-.53-2.71-.55-4.84-2.86-5.77-5.74-2.73-9,.96-19.48-2.71-28.3-1.96-5.04-6.99-8.2-11.77-6.32-3.52,1.25-5.83,4.99-6.47,8.92-1.03,5.69.38,12.13,3.31,17.86,3.1,6.06,7.9,11.32,13.32,14.08.36.18.73.35,1.1.52,3.75,1.65,7.76,2.08,11.68.74.52-.23.84-.52.81-.77v-.04Z"
      />
      <path
        style={{ fill: '#364ebf', strokeWidth: 0 }}
        d="m143.58,39.54c0-10.28,0-22.3,0-28.22,0-6.66-3.15-10.94-7.09-11.01-.04,0-.08,0-.12,0-1.99,0-3.26.8-4.3,1.95-1.87,2.08-2.91,5.48-2.91,9v13.68c.37.16.73.33,1.1.52,5.42,2.76,10.22,8.02,13.32,14.08Z"
      />
      <path
        style={{ fill: '#2fd7ca', strokeWidth: 0 }}
        d="m116.68,25c.03.17.23.31.54.42.91.28,2.01.28,2.96.53,2.71.55,4.84,2.86,5.77,5.74,2.73,9-.96,19.48,2.71,28.3,1.96,5.04,6.99,8.2,11.77,6.32,3.52-1.25,5.83-4.99,6.47-8.92,1.03-5.69-.38-12.13-3.31-17.86-3.1-6.06-7.9-11.32-13.32-14.08-.36-.18-.73-.35-1.1-.52-3.75-1.65-7.76-2.08-11.68-.74-.52.23-.84.52-.81.77v.04Z"
      />
    </g>
  </svg>
);
